
// import React, { useEffect, useState } from 'react';
// import { Tab, Tabs, List, ListItem, Collapse, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, MenuItem, Select, FormControl, InputLabel, Typography, Box, Accordion, AccordionSummary, AccordionDetails, FormHelperText } from '@mui/material';
// import { ExpandLess, ExpandMore, Edit } from '@mui/icons-material';
// import LampDataService from '../../apis/lamps-data';
// import DeviceDataService from '../../apis/device-data';
// import { getSystemUpTimeData } from '../../query/dash-chart-query';
// import { getDashboardMockData, handleSaveData } from '../../query/dash-mock-query';
// import DeviceAddressService from '../../apis/device-address';
// import { typeFilter } from '../../constants/constants';
// import DashboardDataService from '../../apis/dashboard-data';
// import MaterialTable from 'material-table';
// import {
//   MuiThemeProvider,
//   createMuiTheme,
//   makeStyles,
//   createStyles,
// } from "@material-ui/core/styles";
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import { KeyboardDatePicker, KeyboardDateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
// import DateFnsUtils from '@date-io/date-fns';
// import { checkUserAccess, getCheckSession } from '../../apis/auth';
// import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

// const useStyles = makeStyles((theme) =>
//   createStyles({
//     button: {
//       margin: theme.spacing(1),
//     },
//     table: {
//       minWidth: 650,
//     },
//     root: {
//       width: "100%",
//     },
//     instructions: {
//       marginTop: theme.spacing(1),
//       marginBottom: theme.spacing(1),
//     },
//     formControl: {
//       margin: theme.spacing(1),
//       minWidth: 120,
//       marginRight: 20,
//     },
//     selectEmpty: {
//       marginTop: theme.spacing(2),
//     },
//   })
// );
// const ScheduleScreen = () => {
//   // State management
//   const [activeTab, setActiveTab] = useState('out_schedule');
//   const [schedules, setSchedules] = useState([]);
//   const [openAddDialog, setOpenAddDialog] = useState(false);
//   const [openEditDialog, setOpenEditDialog] = useState(false);
//   const [currentEditData, setCurrentEditData] = useState(null);
//   const [expandedDefault, setExpandedDefault] = useState(true);
//   const [expandedFilter, setExpandedFilter] = useState(true);
//   const classes = useStyles();
//   const [newZone, setNewZone] = useState(null);
//   const [zoneList, setZoneList] = useState(null);
//   const [newWard, setNewWard] = useState([]);
//   const [wardList, setWardList] = useState([]);
//   const schStart = new Date();
//   schStart.setHours(9, 0, 0, 0); // 9:00:00.000 AM
//   const schEnd = new Date();
//   schEnd.setHours(18, 0, 0, 0); // 9:00:00.000 AM

//   // Form state for add/edit
//   const [formData, setFormData] = useState({
//     name: '',
//     schStart: schStart,
//     schEnd: schEnd,
//     status: null,
//     type: null,
//     default: {
//       lmpNcCnt: 0,
//       lmpOnCnt: 0,
//       slcCnt: 0,
//       withSlcCnt: 0,
//       lmpOffCnt: 0,
//       ilmErrCnt: 0,
//       outFaults: {
//         hcCnt: 0,
//         tripCnt: 0,
//         cfCnt: 0
//       },
//       inpFaults: {
//         isofCnt: 0,
//         pfCnt: 0,
//         hvCnt: 0,
//         lvCnt: 0
//       },
//       ilmOffCnt: 0,
//       slcErrCnt: 0,
//       slcOffCnt: 0,
//       lmpCnt: 0,
//       othFaults: {
//         lbCnt: 0,
//         inaCnt: 0,
//         doCnt: 0,
//         emfCnt: 0
//       },
//       modes: {
//         autoCnt: 0,
//         manCnt: 0,
//         bypCnt: 0
//       },
//       slcOnCnt: 0,
//       ilmCnt: 0,
//       ilmOnCnt: 0,
//       uthrly: [],
//       utdly: [],
//       ensav: []
//     },
//     filtered: []
//   });

//   const [errors, setErrors] = useState({
//     name: '',
//     schStart: '',
//     schEnd: '',
//     status: ''
//   });

//   const validateForm = () => {
//     let isValid = true;
//     const newErrors = {
//       name: '',
//       schStart: '',
//       schEnd: '',
//       status: ''
//     };

//     // Name validation
//     if (!formData.name.trim()) {
//       newErrors.name = 'Schedule name is required';
//       isValid = false;
//     } else if (formData.name.length > 50) {
//       newErrors.name = 'Name must be less than 50 characters';
//       isValid = false;
//     }

//     // Date validation
//     if (!formData.schStart) {
//       newErrors.schStart = 'Start datetime is required';
//       isValid = false;
//     }

//     if (!formData.schEnd) {
//       newErrors.schEnd = 'End datetime is required';
//       isValid = false;
//     } else {
//       const start = new Date(formData.schStart);
//       const end = new Date(formData.schEnd);

//       if (end <= start) {
//         newErrors.schEnd = 'End time must be after Start time';
//         isValid = false;
//       } else {
//         const diffDays = (end - start) / (1000 * 60 * 60 * 24); // difference in days

//         if (diffDays > 1) {
//           newErrors.schEnd = 'End time must be on the same day or the next day';
//           isValid = false;
//         }
//       }
//     }

//     // Status validation
//     if (formData.status === null || formData.status === '') {
//       newErrors.status = 'Status is required';
//       isValid = false;
//     }

//     setErrors(newErrors);
//     return isValid;
//   };



//   const existingCombinations = formData.filtered?.map(f => `${f.zone}-${f.ward}`) || [];

//   const history = useHistory();
//   useEffect(async () => {

//     var mockStatus = checkUserAccess("mock");
//     var sessionStatus = await getCheckSession();
//     if (sessionStatus === false || mockStatus === false) {
//       history.push("/dashboard");
//       return;
//     }
//     var data = await getDashboardMockData().catch((e) => {
//       console.log("Unable to receive dashboard data");
//       console.log(e)
//     });
//     await DeviceAddressService.getInstance().getAllAddressAPICall();
//     // Get zones from service and filter out any with value 0
//     const zoneList = DeviceAddressService.getInstance().getZones().filter(zone => zone.value !== 0);
//     // Set the filtered list
//     setZoneList(zoneList);
//     if (data != null && data !== undefined) {
//       const processedData = data.mockData.map(item => {
//         const sdate = item.schStart?.toDate?.() || new Date(item.schStart); // handle Firestore Timestamp or raw timestamp
//         const edate = item.schEnd?.toDate?.() || new Date(item.schEnd); // handle Firestore Timestamp or raw timestamp

//         return {
//           ...item,
//           schStart: sdate,
//           schEnd: edate, // e.g., 1 hour later
//         };
//       });

//       const inSchedule = processedData.filter(item => item.type === 1);
//       const outSchedule = processedData.filter(item => item.type === 2);

//       const newSchedule = {
//         in_schedule: inSchedule,
//         out_schedule: outSchedule
//       };
//       console.log(JSON.stringify(newSchedule, null, 2))
//       setSchedules(newSchedule);
//     }
//   }, [])


//   // Handle tab change
//   const handleTabChange = (event, newValue) => {
//     setFormData({
//       name: '',
//       schStart: schStart,
//       schEnd: schEnd,
//       status: null,
//       type: null,
//       default: {
//         lmpNcCnt: 0,
//         lmpOnCnt: 0,
//         slcCnt: 0,
//         lmpOffCnt: 0,
//         ilmErrCnt: 0,
//         outFaults: {
//           hcCnt: 0,
//           tripCnt: 0,
//           cfCnt: 0
//         },
//         inpFaults: {
//           isofCnt: 0,
//           pfCnt: 0,
//           hvCnt: 0,
//           lvCnt: 0
//         },
//         ilmOffCnt: 0,
//         slcErrCnt: 0,
//         slcOffCnt: 0,
//         lmpCnt: 0,
//         othFaults: {
//           lbCnt: 0,
//           inaCnt: 0,
//           doCnt: 0,
//           emfCnt: 0
//         },
//         modes: {
//           autoCnt: 0,
//           manCnt: 0,
//           bypCnt: 0
//         },
//         slcOnCnt: 0,
//         ilmCnt: 0,
//         ilmOnCnt: 0,
//         uthrly: [],
//         utdly: [],
//         ensav: []
//       },
//       filtered: []
//     });
//     setActiveTab(newValue);
//   };

//   // Handle add new schedule
//   const handleAddSchedule = () => {
//     setOpenAddDialog(true);
//   };

//   // Handle edit schedule
//   const handleEditSchedule = (schedule) => {
//     setCurrentEditData(schedule);
//     setFormData(schedule);
//     setOpenEditDialog(true);
//   };

//   const handleSave = () => {
//     if (!validateForm()) {
//       return; // Don't proceed if validation fails
//     }
//     // Initialize schedules with empty arrays if undefined
//     const updatedSchedules = {
//       in_schedule: schedules.in_schedule || [],
//       out_schedule: schedules.out_schedule || []
//     };

//     // Determine target schedule based on activeTab
//     const targetSchedule = activeTab === 'in_schedule' ? 'in_schedule' : 'out_schedule';

//     if (currentEditData) {
//       // Remove from old position (in case type changed)
//       ['in_schedule', 'out_schedule'].forEach(scheduleType => {
//         updatedSchedules[scheduleType] = (updatedSchedules[scheduleType] || []).filter(
//           s => s.name !== currentEditData.name
//         );
//       });

//       // Add to new position
//       updatedSchedules[targetSchedule] = [...(updatedSchedules[targetSchedule] || []), formData];
//     } else {
//       // Add new item with type
//       const newItem = {
//         ...formData,
//         type: activeTab === 'in_schedule' ? 1 : 2
//       };
//       updatedSchedules[targetSchedule] = [...(updatedSchedules[targetSchedule] || []), newItem];
//     }

//     setSchedules(updatedSchedules);
//     setCurrentEditData(null);
//     setOpenAddDialog(false);
//     setOpenEditDialog(false);
//     setCurrentEditData(null);
//     // Reset form
//     setFormData({
//       name: '',
//       schStart: schStart,
//       schEnd: schEnd,
//       status: null,
//       type: null,
//       default: {
//         lmpNcCnt: 0,
//         lmpOnCnt: 0,
//         withSlcCnt: 0,
//         slcCnt: 0,
//         lmpOffCnt: 0,
//         ilmErrCnt: 0,
//         outFaults: {
//           hcCnt: 0,
//           tripCnt: 0,
//           cfCnt: 0
//         },
//         inpFaults: {
//           isofCnt: 0,
//           pfCnt: 0,
//           hvCnt: 0,
//           lvCnt: 0
//         },
//         ilmOffCnt: 0,
//         slcErrCnt: 0,
//         slcOffCnt: 0,
//         lmpCnt: 0,
//         othFaults: {
//           lbCnt: 0,
//           inaCnt: 0,
//           doCnt: 0,
//           emfCnt: 0
//         },
//         modes: {
//           autoCnt: 0,
//           manCnt: 0,
//           bypCnt: 0
//         },
//         slcOnCnt: 0,
//         ilmCnt: 0,
//         ilmOnCnt: 0,
//         uthrly: [],
//         utdly: [],
//         ensav: []
//       },
//       filtered: []
//     });
//     handleSaveData(updatedSchedules);
//   };


//   const [editTab, setEditTab] = useState(0); // For tracking which tab is active in edit dialog

//   const getScheduleDataColumnList = () => {
//     return [
//       {
//         title: 'NAME',
//         field: "name",
//         searchable: true,
//         render: ({ name = 'N/A' }) => {
//           return name;
//         },
//         exportTransformer: ({ name = 'N/A' }) => {
//           return name;
//         }
//       },
//       {
//         title: 'STATUS',
//         render: ({ status = 'N/A' }) => {
//           return status.replace('_', '');
//         },
//         exportTransformer: ({ status = 'N/A' }) => {
//           return status.replace('_', '');
//         }
//       },
//       {
//         title: 'START DATE',
//         type: 'datetime',
//         render: ({ schStart = 'N/A' }) => {
//           if (schStart === 'N/A') return 'N/A';
//           const date = new Date(schStart);
//           return date.toLocaleString('en-GB', {
//             day: '2-digit',
//             month: 'short',
//             year: 'numeric',
//             hour: '2-digit',
//             minute: '2-digit',
//             hour12: true,
//           });
//         },
//         exportTransformer: ({ schStart = 'N/A' }) => {
//           if (schStart === 'N/A') return 'N/A';
//           const date = new Date(schStart);
//           return date.toLocaleString('en-GB', {
//             day: '2-digit',
//             month: 'short',
//             year: 'numeric',
//             hour: '2-digit',
//             minute: '2-digit',
//             hour12: true,
//           });
//         },
//       },
//       {
//         title: 'END DATE',
//         type: 'datetime',
//         render: ({ schEnd = 'N/A' }) => {
//           if (schEnd === 'N/A') return 'N/A';
//           const date = new Date(schEnd);
//           return date.toLocaleString('en-GB', {
//             day: '2-digit',
//             month: 'short',
//             year: 'numeric',
//             hour: '2-digit',
//             minute: '2-digit',
//             hour12: true,
//           });
//         },
//         exportTransformer: ({ schEnd = 'N/A' }) => {
//           if (schEnd === 'N/A') return 'N/A';
//           const date = new Date(schEnd);
//           return date.toLocaleString('en-GB', {
//             day: '2-digit',
//             month: 'short',
//             year: 'numeric',
//             hour: '2-digit',
//             minute: '2-digit',
//             hour12: true,
//           });
//         },
//       },
//       {
//         title: 'TOTAL LAMPS',
//         render: ({ default: defaultData = {} }) => {
//           return defaultData.lmpCnt || 0;
//         },
//         exportTransformer: ({ default: defaultData = {} }) => {
//           return defaultData.lmpCnt || 0;
//         }
//       },
//       {
//         title: 'LAMPS ON',
//         render: ({ default: defaultData = {} }) => {
//           return defaultData.lmpOnCnt || 0;
//         },
//         exportTransformer: ({ default: defaultData = {} }) => {
//           return defaultData.lmpOnCnt || 0;
//         }
//       },
//       {
//         title: 'LAMPS OFF',
//         render: ({ default: defaultData = {} }) => {
//           return defaultData.lmpOffCnt || 0;
//         },
//         exportTransformer: ({ default: defaultData = {} }) => {
//           return defaultData.lmpOffCnt || 0;
//         }
//       },
//       {
//         title: 'LAMPS NC',
//         render: ({ default: defaultData = {} }) => {
//           return defaultData.lmpNcCnt || 0;
//         },
//         exportTransformer: ({ default: defaultData = {} }) => {
//           return defaultData.lmpNcCnt || 0;
//         }
//       },
//       {
//         title: 'SLC COUNT',
//         render: ({ default: defaultData = {} }) => {
//           return defaultData.withSlcCnt || 0;
//         },
//         exportTransformer: ({ default: defaultData = {} }) => {
//           return defaultData.withSlcCnt || 0;
//         }
//       },
//       {
//         title: 'SLC COUNT',
//         render: ({ default: defaultData = {} }) => {
//           return defaultData.slcCnt || 0;
//         },
//         exportTransformer: ({ default: defaultData = {} }) => {
//           return defaultData.slcCnt || 0;
//         }
//       },
//       {
//         title: 'SLC ON',
//         render: ({ default: defaultData = {} }) => {
//           return defaultData.slcOnCnt || 0;
//         },
//         exportTransformer: ({ default: defaultData = {} }) => {
//           return defaultData.slcOnCnt || 0;
//         }
//       },
//       {
//         title: 'SLC OFF',
//         render: ({ default: defaultData = {} }) => {
//           return defaultData.slcOffCnt || 0;
//         },
//         exportTransformer: ({ default: defaultData = {} }) => {
//           return defaultData.slcOffCnt || 0;
//         }
//       },
//       {
//         title: 'ILM COUNT',
//         render: ({ default: defaultData = {} }) => {
//           return defaultData.ilmCnt || 0;
//         },
//         exportTransformer: ({ default: defaultData = {} }) => {
//           return defaultData.ilmCnt || 0;
//         }
//       },
//       {
//         title: 'ILM ON',
//         render: ({ default: defaultData = {} }) => {
//           return defaultData.ilmOnCnt || 0;
//         },
//         exportTransformer: ({ default: defaultData = {} }) => {
//           return defaultData.ilmOnCnt || 0;
//         }
//       },
//       {
//         title: 'ILM OFF',
//         render: ({ default: defaultData = {} }) => {
//           return defaultData.ilmOffCnt || 0;
//         },
//         exportTransformer: ({ default: defaultData = {} }) => {
//           return defaultData.ilmOffCnt || 0;
//         }
//       },
//       {
//         title: 'AUTO MODE',
//         render: ({ default: defaultData = {} }) => {
//           return defaultData.modes?.autoCnt || 0;
//         },
//         exportTransformer: ({ default: defaultData = {} }) => {
//           return defaultData.modes?.autoCnt || 0;
//         }
//       },
//       {
//         title: 'MANUAL MODE',
//         render: ({ default: defaultData = {} }) => {
//           return defaultData.modes?.manCnt || 0;
//         },
//         exportTransformer: ({ default: defaultData = {} }) => {
//           return defaultData.modes?.manCnt || 0;
//         }
//       },
//       {
//         title: 'BYPASS MODE',
//         render: ({ default: defaultData = {} }) => {
//           return defaultData.modes?.bypCnt || 0;
//         },
//         exportTransformer: ({ default: defaultData = {} }) => {
//           return defaultData.modes?.bypCnt || 0;
//         }
//       },
//       {
//         title: 'TRIP FAULTS',
//         render: ({ default: defaultData = {} }) => {
//           return defaultData.outFaults?.tripCnt || 0;
//         },
//         exportTransformer: ({ default: defaultData = {} }) => {
//           return defaultData.outFaults?.tripCnt || 0;
//         }
//       },
//       {
//         title: 'CF FAULTS',
//         render: ({ default: defaultData = {} }) => {
//           return defaultData.outFaults?.cfCnt || 0;
//         },
//         exportTransformer: ({ default: defaultData = {} }) => {
//           return defaultData.outFaults?.cfCnt || 0;
//         }
//       },
//       {
//         title: 'HC FAULTS',
//         render: ({ default: defaultData = {} }) => {
//           return defaultData.outFaults?.hcCnt || 0;
//         },
//         exportTransformer: ({ default: defaultData = {} }) => {
//           return defaultData.outFaults?.hcCnt || 0;
//         }
//       },
//       {
//         title: 'POWER FAULTS',
//         render: ({ default: defaultData = {} }) => {
//           return defaultData.inpFaults?.pfCnt || 0;
//         },
//         exportTransformer: ({ default: defaultData = {} }) => {
//           return defaultData.inpFaults?.pfCnt || 0;
//         }
//       },
//       {
//         title: 'LOW VOLTAGE',
//         render: ({ default: defaultData = {} }) => {
//           return defaultData.inpFaults?.lvCnt || 0;
//         },
//         exportTransformer: ({ default: defaultData = {} }) => {
//           return defaultData.inpFaults?.lvCnt || 0;
//         }
//       },
//       {
//         title: 'HIGH VOLTAGE',
//         render: ({ default: defaultData = {} }) => {
//           return defaultData.inpFaults?.hvCnt || 0;
//         },
//         exportTransformer: ({ default: defaultData = {} }) => {
//           return defaultData.inpFaults?.hvCnt || 0;
//         }
//       },
//       {
//         title: 'ISOF FAULTS',
//         render: ({ default: defaultData = {} }) => {
//           return defaultData.inpFaults?.isofCnt || 0;
//         },
//         exportTransformer: ({ default: defaultData = {} }) => {
//           return defaultData.inpFaults?.isofCnt || 0;
//         }
//       },
//       {
//         title: 'LOW BATTERY',
//         render: ({ default: defaultData = {} }) => {
//           return defaultData.othFaults?.lbCnt || 0;
//         },
//         exportTransformer: ({ default: defaultData = {} }) => {
//           return defaultData.othFaults?.lbCnt || 0;
//         }
//       },
//       {
//         title: 'DOOR OPEN',
//         render: ({ default: defaultData = {} }) => {
//           return defaultData.othFaults?.doCnt || 0;
//         },
//         exportTransformer: ({ default: defaultData = {} }) => {
//           return defaultData.othFaults?.doCnt || 0;
//         }
//       },
//       {
//         title: 'EMF FAULTS',
//         render: ({ default: defaultData = {} }) => {
//           return defaultData.othFaults?.emfCnt || 0;
//         },
//         exportTransformer: ({ default: defaultData = {} }) => {
//           return defaultData.othFaults?.emfCnt || 0;
//         }
//       },
//       {
//         title: 'INACTIVE',
//         render: ({ default: defaultData = {} }) => {
//           return defaultData.othFaults?.inaCnt || 0;
//         },
//         exportTransformer: ({ default: defaultData = {} }) => {
//           return defaultData.othFaults?.inaCnt || 0;
//         }
//       },
//       {
//         title: 'ENERGY SAVINGS',
//         render: (rowData) => {
//           if (rowData.default && rowData.default.ensav && rowData.default.ensav.length > 0) {
//             const averageESP = rowData.default.ensav.reduce((sum, item) => sum + item.esp, 0) / rowData.default.ensav.length;
//             return `${averageESP.toFixed(2)}%`;
//           }
//           return "0%";
//         },
//         exportTransformer: (rowData) => {
//           if (rowData.default && rowData.default.ensav && rowData.default.ensav.length > 0) {
//             const averageESP = rowData.default.ensav.reduce((sum, item) => sum + item.esp, 0) / rowData.default.ensav.length;
//             return `${averageESP.toFixed(2)}%`;
//           }
//           return "0%";
//         }
//       },
//       {
//         title: 'ZONE COUNT',
//         render: ({ filtered = [] }) => {
//           return filtered.length;
//         },
//         exportTransformer: ({ filtered = [] }) => {
//           return filtered.length;
//         }
//       }
//     ];
//   };



//   const handleDateChange = (date, dateField) => {
//     setFormData((prevState) => ({
//       ...prevState,
//       [dateField]: date,
//     }));
//   };

//   return (
//     <div className="reports">
//       <Tabs value={activeTab} onChange={handleTabChange}>
//         <Tab label="OUT Schedule" value="out_schedule" />
//         <Tab label="IN Schedule" value="in_schedule" />
//       </Tabs>

//       <div className="dashboard-table">
//         <MaterialTable
//           style={{
//             margin: "20px 0",
//             width: "100%",
//           }}
//           className={classes.table}
//           title=""
//           columns={getScheduleDataColumnList()}
//           data={schedules[activeTab] || []}  // Use all items in the activeTab array
//           onRowClick={(evt, rowData) => {
//             handleEditSchedule(rowData);
//           }}
//           actions={[
//             // {
//             //   icon: 'save',
//             //   tooltip: 'Save Schedule',
//             //   isFreeAction: true,
//             //   onClick: (event, rowData) => {
//             //     handleSaveData(rowData)
//             //   }
//             // },
//             {
//               icon: 'add',
//               tooltip: 'Add Schedule',
//               isFreeAction: true,
//               onClick: (event, rowData) => {
//                 handleAddSchedule(rowData);
//               }
//             }
//           ]}
//           options={{
//             // exportButton: true,
//             // exportAllData: true,
//             // search: true,
//             selection: false,
//             sorting: true,
//             pageSize: 10,
//             headerStyle: {
//               backgroundColor: "#0071CE",
//               color: "#FFF",
//               fontSize: "0.9em",
//               textAlign: "center",
//             },
//             actionsColumnIndex: -1,
//             emptyRowsWhenPaging: false,
//           }}
//         // localization={{
//         //   toolbar: {
//         // searchPlaceholder: "Search",
//         //   exportCSVName: "Export as Excel",
//         //   exportPDFName: "Export as PDF",
//         // },
//         // }}
//         />
//       </div>


//       {/* Add Schedule Dialog */}
//       <Dialog open={openAddDialog} onClose={() => setOpenAddDialog(false)}>
//         <DialogTitle>Add New {activeTab == 'in_schedule' ? 'In' : 'Out'} Schedule</DialogTitle>
//         <DialogContent>
//           <TextField
//             autoFocus
//             margin="dense"
//             label="Name"
//             fullWidth
//             value={formData.name}
//             error={!!errors.name}
//             helperText={errors.name}
//             onChange={(e) => setFormData({ ...formData, name: e.target.value })}
//           />
//           <FormControl variant="outlined" fullWidth style={{ marginTop: '10px' }}>
//             <MuiPickersUtilsProvider utils={DateFnsUtils}>
//               <KeyboardDateTimePicker
//                 clearable
//                 autoOk
//                 error={!!errors.schStart}
//                 helperText={errors.schStart}
//                 label="Start Date & Time"
//                 value={formData.schStart}
//                 placeholder="dd/MM/yyyy HH:mm"
//                 InputAdornmentProps={{ position: "end" }}
//                 onChange={(date) => handleDateChange(date, "schStart")}
//                 variant="inline"
//                 inputVariant="outlined"
//                 format="dd/MM/yyyy HH:mm"
//               />
//             </MuiPickersUtilsProvider>
//           </FormControl>

//           <FormControl variant="outlined" fullWidth style={{ marginTop: '10px' }}>
//             <MuiPickersUtilsProvider utils={DateFnsUtils}>
//               <KeyboardDateTimePicker
//                 clearable
//                 autoOk
//                 error={!!errors.schEnd}
//                 helperText={errors.schEnd}
//                 label="End Date & Time"
//                 value={formData.schEnd}
//                 placeholder="dd/MM/yyyy HH:mm"
//                 InputAdornmentProps={{ position: "end" }}
//                 onChange={(date) => handleDateChange(date, "schEnd")}
//                 variant="inline"
//                 inputVariant="outlined"
//                 format="dd/MM/yyyy HH:mm"
//                 minDate={formData.schStart}
//                 minDateMessage="End time must be after start time"
//               />
//             </MuiPickersUtilsProvider>
//           </FormControl>

//           <FormControl error={!!errors.status} style={{ marginTop: '10px' }}
//             fullWidth margin="dense">
//             <InputLabel>Status</InputLabel>
//             <Select
//               value={formData.status}
//               onChange={(e) => setFormData({ ...formData, status: e.target.value })}
//             >
//               <MenuItem value="active">Active</MenuItem>
//               <MenuItem value="inactive">Inactive</MenuItem>
//             </Select>
//             {errors.status && <FormHelperText>{errors.status}</FormHelperText>}

//           </FormControl>

//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenAddDialog(false)}>Cancel</Button>
//           <Button onClick={handleSave} color="primary">OK</Button>
//         </DialogActions>
//       </Dialog>


//       <Dialog open={openEditDialog} onClose={() => setOpenEditDialog(false)} fullWidth maxWidth="md">
//         <DialogTitle>Edit {activeTab == 'in_schedule' ? 'In' : 'Out'} Schedule</DialogTitle>
//         <DialogContent>
//           <Tabs value={editTab} onChange={(e, newValue) => setEditTab(newValue)}>
//             <Tab label="Basic Info" />
//             <Tab label="Default Data" />
//             <Tab label="Filtered Data" />
//           </Tabs>

//           {/* Basic Info Tab */}
//           {editTab === 0 && (
//             <div style={{ marginTop: '20px' }}>
//               <TextField
//                 margin="dense"
//                 label="Name"
//                 fullWidth
//                 value={formData.name}
//                 onChange={(e) => setFormData({ ...formData, name: e.target.value })}
//               />
//               <FormControl variant="outlined" fullWidth style={{ marginTop: '10px' }}>
//                 <MuiPickersUtilsProvider utils={DateFnsUtils}>
//                   <KeyboardDateTimePicker
//                     clearable
//                     autoOk
//                     error={!!errors.schStart}
//                     helperText={errors.schStart}
//                     label="Start Date & Time"
//                     value={formData.schStart}
//                     placeholder="dd/MM/yyyy HH:mm"
//                     InputAdornmentProps={{ position: "end" }}
//                     onChange={(date) => handleDateChange(date, "schStart")}
//                     variant="inline"
//                     inputVariant="outlined"
//                     format="dd/MM/yyyy HH:mm"
//                   />
//                 </MuiPickersUtilsProvider>
//               </FormControl>

//               <FormControl variant="outlined" fullWidth style={{ marginTop: '10px' }}>
//                 <MuiPickersUtilsProvider utils={DateFnsUtils}>
//                   <KeyboardDateTimePicker
//                     clearable
//                     autoOk
//                     error={!!errors.schEnd}
//                     helperText={errors.schEnd}
//                     label="End Date & Time"
//                     value={formData.schEnd}
//                     placeholder="dd/MM/yyyy HH:mm"
//                     InputAdornmentProps={{ position: "end" }}
//                     onChange={(date) => handleDateChange(date, "schEnd")}
//                     variant="inline"
//                     inputVariant="outlined"
//                     format="dd/MM/yyyy HH:mm"
//                     minDate={formData.schStart}
//                     minDateMessage="End time must be after start time"
//                   />
//                 </MuiPickersUtilsProvider>
//               </FormControl>

//               <FormControl fullWidth margin="dense">
//                 <InputLabel>Status</InputLabel>
//                 <Select
//                   value={formData.status}
//                   onChange={(e) => setFormData({ ...formData, status: e.target.value })}
//                 >
//                   <MenuItem value="active">Active</MenuItem>
//                   <MenuItem value="inactive">Inactive</MenuItem>
//                 </Select>
//               </FormControl>

//             </div>
//           )}

//           {/* Default Data Tab */}
//           {editTab === 1 && (
//             <div style={{ marginTop: '20px', display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px' }}>
//               {/* LMP Fields */}
//               <TextField
//                 label="LMP Count"
//                 type="number"
//                 value={formData.default.lmpCnt}
//                 onChange={(e) => setFormData({
//                   ...formData,
//                   default: { ...formData.default, lmpCnt: parseInt(e.target.value) || 0 }
//                 })}
//               />
//               <TextField
//                 label="LMP On Count"
//                 type="number"
//                 value={formData.default.lmpOnCnt}
//                 onChange={(e) => setFormData({
//                   ...formData,
//                   default: { ...formData.default, lmpOnCnt: parseInt(e.target.value) || 0 }
//                 })}
//               />
//               <TextField
//                 label="LMP NC Count"
//                 type="number"
//                 value={formData.default.lmpNcCnt}
//                 onChange={(e) => setFormData({
//                   ...formData,
//                   default: { ...formData.default, lmpNcCnt: parseInt(e.target.value) || 0 }
//                 })}
//               />
//               <TextField
//                 label="LMP Off Count"
//                 type="number"
//                 value={formData.default.lmpOffCnt}
//                 onChange={(e) => setFormData({
//                   ...formData,
//                   default: { ...formData.default, lmpOffCnt: parseInt(e.target.value) || 0 }
//                 })}
//               />

//               {/* SLC Fields */}
//               <TextField
//                 label="With SLC Count"
//                 type="number"
//                 value={formData.default.withSlcCnt}
//                 onChange={(e) => setFormData({
//                   ...formData,
//                   default: { ...formData.default, withSlcCnt: parseInt(e.target.value) || 0 }
//                 })}
//               />
//               <TextField
//                 label="SLC Count"
//                 type="number"
//                 value={formData.default.slcCnt}
//                 onChange={(e) => setFormData({
//                   ...formData,
//                   default: { ...formData.default, slcCnt: parseInt(e.target.value) || 0 }
//                 })}
//               />
//               <TextField
//                 label="SLC On Count"
//                 type="number"
//                 value={formData.default.slcOnCnt}
//                 onChange={(e) => setFormData({
//                   ...formData,
//                   default: { ...formData.default, slcOnCnt: parseInt(e.target.value) || 0 }
//                 })}
//               />
//               <TextField
//                 label="SLC Off Count"
//                 type="number"
//                 value={formData.default.slcOffCnt}
//                 onChange={(e) => setFormData({
//                   ...formData,
//                   default: { ...formData.default, slcOffCnt: parseInt(e.target.value) || 0 }
//                 })}
//               />
//               <TextField
//                 label="SLC Error Count"
//                 type="number"
//                 value={formData.default.slcErrCnt}
//                 onChange={(e) => setFormData({
//                   ...formData,
//                   default: { ...formData.default, slcErrCnt: parseInt(e.target.value) || 0 }
//                 })}
//               />

//               {/* ILM Fields */}
//               <TextField
//                 label="ILM Count"
//                 type="number"
//                 value={formData.default.ilmCnt}
//                 onChange={(e) => setFormData({
//                   ...formData,
//                   default: { ...formData.default, ilmCnt: parseInt(e.target.value) || 0 }
//                 })}
//               />
//               <TextField
//                 label="ILM On Count"
//                 type="number"
//                 value={formData.default.ilmOnCnt}
//                 onChange={(e) => setFormData({
//                   ...formData,
//                   default: { ...formData.default, ilmOnCnt: parseInt(e.target.value) || 0 }
//                 })}
//               />
//               <TextField
//                 label="ILM Off Count"
//                 type="number"
//                 value={formData.default.ilmOffCnt}
//                 onChange={(e) => setFormData({
//                   ...formData,
//                   default: { ...formData.default, ilmOffCnt: parseInt(e.target.value) || 0 }
//                 })}
//               />
//               <TextField
//                 label="ILM Error Count"
//                 type="number"
//                 value={formData.default.ilmErrCnt}
//                 onChange={(e) => setFormData({
//                   ...formData,
//                   default: { ...formData.default, ilmErrCnt: parseInt(e.target.value) || 0 }
//                 })}
//               />

//               {/* Input Faults */}
//               <div style={{ gridColumn: 'span 2', borderBottom: '1px solid #eee', paddingBottom: '8px', marginBottom: '8px' }}>
//                 <h4>Input Faults</h4>
//               </div>
//               <TextField
//                 label="PF Count"
//                 type="number"
//                 value={formData.default.inpFaults?.pfCnt}
//                 onChange={(e) => setFormData({
//                   ...formData,
//                   default: {
//                     ...formData.default,
//                     inpFaults: { ...formData.default.inpFaults, pfCnt: parseInt(e.target.value) || 0 }
//                   }
//                 })}
//               />
//               <TextField
//                 label="LV Count"
//                 type="number"
//                 value={formData.default.inpFaults?.lvCnt}
//                 onChange={(e) => setFormData({
//                   ...formData,
//                   default: {
//                     ...formData.default,
//                     inpFaults: { ...formData.default.inpFaults, lvCnt: parseInt(e.target.value) || 0 }
//                   }
//                 })}
//               />
//               <TextField
//                 label="HV Count"
//                 type="number"
//                 value={formData.default.inpFaults?.hvCnt}
//                 onChange={(e) => setFormData({
//                   ...formData,
//                   default: {
//                     ...formData.default,
//                     inpFaults: { ...formData.default.inpFaults, hvCnt: parseInt(e.target.value) || 0 }
//                   }
//                 })}
//               />
//               <TextField
//                 label="IsoF Count"
//                 type="number"
//                 value={formData.default.inpFaults?.isofCnt}
//                 onChange={(e) => setFormData({
//                   ...formData,
//                   default: {
//                     ...formData.default,
//                     inpFaults: { ...formData.default.inpFaults, isofCnt: parseInt(e.target.value) || 0 }
//                   }
//                 })}
//               />

//               {/* Output Faults */}
//               <div style={{ gridColumn: 'span 2', borderBottom: '1px solid #eee', paddingBottom: '8px', marginBottom: '8px' }}>
//                 <h4>Output Faults</h4>
//               </div>
//               <TextField
//                 label="HC Count"
//                 type="number"
//                 value={formData.default.outFaults?.hcCnt}
//                 onChange={(e) => setFormData({
//                   ...formData,
//                   default: {
//                     ...formData.default,
//                     outFaults: { ...formData.default.outFaults, hcCnt: parseInt(e.target.value) || 0 }
//                   }
//                 })}
//               />
//               <TextField
//                 label="Trip Count"
//                 type="number"
//                 value={formData.default.outFaults?.tripCnt}
//                 onChange={(e) => setFormData({
//                   ...formData,
//                   default: {
//                     ...formData.default,
//                     outFaults: { ...formData.default.outFaults, tripCnt: parseInt(e.target.value) || 0 }
//                   }
//                 })}
//               />
//               <TextField
//                 label="CF Count"
//                 type="number"
//                 value={formData.default.outFaults?.cfCnt}
//                 onChange={(e) => setFormData({
//                   ...formData,
//                   default: {
//                     ...formData.default,
//                     outFaults: { ...formData.default.outFaults, cfCnt: parseInt(e.target.value) || 0 }
//                   }
//                 })}
//               />

//               {/* Other Faults */}
//               <div style={{ gridColumn: 'span 2', borderBottom: '1px solid #eee', paddingBottom: '8px', marginBottom: '8px' }}>
//                 <h4>Other Faults</h4>
//               </div>
//               <TextField
//                 label="LB Count"
//                 type="number"
//                 value={formData.default.othFaults?.lbCnt}
//                 onChange={(e) => setFormData({
//                   ...formData,
//                   default: {
//                     ...formData.default,
//                     othFaults: { ...formData.default.othFaults, lbCnt: parseInt(e.target.value) || 0 }
//                   }
//                 })}
//               />
//               <TextField
//                 label="INA Count"
//                 type="number"
//                 value={formData.default.othFaults?.inaCnt}
//                 onChange={(e) => setFormData({
//                   ...formData,
//                   default: {
//                     ...formData.default,
//                     othFaults: { ...formData.default.othFaults, inaCnt: parseInt(e.target.value) || 0 }
//                   }
//                 })}
//               />
//               <TextField
//                 label="DO Count"
//                 type="number"
//                 value={formData.default.othFaults?.doCnt}
//                 onChange={(e) => setFormData({
//                   ...formData,
//                   default: {
//                     ...formData.default,
//                     othFaults: { ...formData.default.othFaults, doCnt: parseInt(e.target.value) || 0 }
//                   }
//                 })}
//               />
//               <TextField
//                 label="EMF Count"
//                 type="number"
//                 value={formData.default.othFaults?.emfCnt}
//                 onChange={(e) => setFormData({
//                   ...formData,
//                   default: {
//                     ...formData.default,
//                     othFaults: { ...formData.default.othFaults, emfCnt: parseInt(e.target.value) || 0 }
//                   }
//                 })}
//               />

//               {/* Modes */}
//               <div style={{ gridColumn: 'span 2', borderBottom: '1px solid #eee', paddingBottom: '8px', marginBottom: '8px' }}>
//                 <h4>Modes</h4>
//               </div>
//               <TextField
//                 label="Auto Count"
//                 type="number"
//                 value={formData.default.modes?.autoCnt}
//                 onChange={(e) => setFormData({
//                   ...formData,
//                   default: {
//                     ...formData.default,
//                     modes: { ...formData.default.modes, autoCnt: parseInt(e.target.value) || 0 }
//                   }
//                 })}
//               />
//               <TextField
//                 label="Man Count"
//                 type="number"
//                 value={formData.default.modes?.manCnt}
//                 onChange={(e) => setFormData({
//                   ...formData,
//                   default: {
//                     ...formData.default,
//                     modes: { ...formData.default.modes, manCnt: parseInt(e.target.value) || 0 }
//                   }
//                 })}
//               />
//               <TextField
//                 label="Byp Count"
//                 type="number"
//                 value={formData.default.modes?.bypCnt}
//                 onChange={(e) => setFormData({
//                   ...formData,
//                   default: {
//                     ...formData.default,
//                     modes: { ...formData.default.modes, bypCnt: parseInt(e.target.value) || 0 }
//                   }
//                 })}
//               />
//               <div style={{ gridColumn: 'span 2' }}>
//                 <h4>Hourly Data (uthrly)</h4>
//                 {formData?.default?.uthrly?.map((hour, idx) => (
//                   <div key={idx} style={{ border: '1px solid #ddd', padding: '10px', marginBottom: '10px' }}>
//                     <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//                       <h5>Hour {idx + 1}</h5>
//                       <Button
//                         size="small"
//                         onClick={() => {
//                           const newUthrly = [...formData.default.uthrly];
//                           newUthrly.splice(idx, 1);
//                           setFormData({
//                             ...formData,
//                             default: { ...formData.default, uthrly: newUthrly }
//                           });
//                         }}
//                       >
//                         Remove
//                       </Button>
//                     </div>
//                     <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px' }}>
//                       <TextField
//                         label="NC Count"
//                         type="number"
//                         value={hour.ncCnt}
//                         onChange={(e) => {
//                           const newUthrly = [...formData.default.uthrly];
//                           newUthrly[idx].ncCnt = parseInt(e.target.value) || 0;
//                           setFormData({
//                             ...formData,
//                             default: { ...formData.default, uthrly: newUthrly }
//                           });
//                         }}
//                       />
//                       <TextField
//                         label="ON Count"
//                         type="number"
//                         value={hour.onCnt}
//                         onChange={(e) => {
//                           const newUthrly = [...formData.default.uthrly];
//                           newUthrly[idx].onCnt = parseInt(e.target.value) || 0;
//                           setFormData({
//                             ...formData,
//                             default: { ...formData.default, uthrly: newUthrly }
//                           });
//                         }}
//                       />
//                       <TextField
//                         label="OFF Count"
//                         type="number"
//                         value={hour.offCnt}
//                         onChange={(e) => {
//                           const newUthrly = [...formData.default.uthrly];
//                           newUthrly[idx].offCnt = parseInt(e.target.value) || 0;
//                           setFormData({
//                             ...formData,
//                             default: { ...formData.default, uthrly: newUthrly }
//                           });
//                         }}
//                       />
//                       <TextField
//                         label="Total Count"
//                         type="number"
//                         value={hour.totCnt}
//                         onChange={(e) => {
//                           const newUthrly = [...formData.default.uthrly];
//                           newUthrly[idx].totCnt = parseInt(e.target.value) || 0;
//                           setFormData({
//                             ...formData,
//                             default: { ...formData.default, uthrly: newUthrly }
//                           });
//                         }}
//                       />
//                     </div>
//                   </div>
//                 ))}
//                 <Button
//                   variant="outlined"
//                   onClick={() => {
//                     setFormData({
//                       ...formData,
//                       default: {
//                         ...formData.default,
//                         uthrly: [
//                           ...formData.default.uthrly,
//                           { ncCnt: 0, onCnt: 0, offCnt: 0, totCnt: 0 }
//                         ]
//                       }
//                     });
//                   }}
//                 >
//                   Add Hourly Data
//                 </Button>
//               </div>

//               {/* utdly Array Editor */}
//               <div style={{ gridColumn: 'span 2' }}>
//                 <h4>Daily Data (utdly)</h4>
//                 {formData?.default?.utdly?.map((day, idx) => (
//                   <div key={idx} style={{ border: '1px solid #ddd', padding: '10px', marginBottom: '10px' }}>
//                     <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//                       <h5>Day {idx + 1}</h5>
//                       <Button
//                         size="small"
//                         onClick={() => {
//                           const newUtdly = [...formData.default.utdly];
//                           newUtdly.splice(idx, 1);
//                           setFormData({
//                             ...formData,
//                             default: { ...formData.default, utdly: newUtdly }
//                           });
//                         }}
//                       >
//                         Remove
//                       </Button>
//                     </div>
//                     <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px' }}>
//                       <TextField
//                         label="NC Count"
//                         type="number"
//                         value={day.ncCnt}
//                         onChange={(e) => {
//                           const newUtdly = [...formData.default.utdly];
//                           newUtdly[idx].ncCnt = parseInt(e.target.value) || 0;
//                           setFormData({
//                             ...formData,
//                             default: { ...formData.default, utdly: newUtdly }
//                           });
//                         }}
//                       />
//                       <TextField
//                         label="ON Count"
//                         type="number"
//                         value={day.onCnt}
//                         onChange={(e) => {
//                           const newUtdly = [...formData.default.utdly];
//                           newUtdly[idx].onCnt = parseInt(e.target.value) || 0;
//                           setFormData({
//                             ...formData,
//                             default: { ...formData.default, utdly: newUtdly }
//                           });
//                         }}
//                       />
//                       <TextField
//                         label="OFF Count"
//                         type="number"
//                         value={day.offCnt}
//                         onChange={(e) => {
//                           const newUtdly = [...formData.default.utdly];
//                           newUtdly[idx].offCnt = parseInt(e.target.value) || 0;
//                           setFormData({
//                             ...formData,
//                             default: { ...formData.default, utdly: newUtdly }
//                           });
//                         }}
//                       />
//                       <TextField
//                         label="Total Count"
//                         type="number"
//                         value={day.totCnt}
//                         onChange={(e) => {
//                           const newUtdly = [...formData.default.utdly];
//                           newUtdly[idx].totCnt = parseInt(e.target.value) || 0;
//                           setFormData({
//                             ...formData,
//                             default: { ...formData.default, utdly: newUtdly }
//                           });
//                         }}
//                       />
//                     </div>
//                   </div>
//                 ))}
//                 <Button
//                   variant="outlined"
//                   onClick={() => {
//                     setFormData({
//                       ...formData,
//                       default: {
//                         ...formData.default,
//                         utdly: [
//                           ...formData.default.utdly,
//                           { ncCnt: 0, onCnt: 0, offCnt: 0, totCnt: 0 }
//                         ]
//                       }
//                     });
//                   }}
//                 >
//                   Add Daily Data
//                 </Button>
//               </div>

//               {/* ensav Array Editor */}
//               <div style={{ gridColumn: 'span 2' }}>
//                 <h4>Energy Savings (ensav)</h4>
//                 {formData?.default?.ensav?.map((saving, idx) => (
//                   <div key={idx} style={{ border: '1px solid #ddd', padding: '10px', marginBottom: '10px' }}>
//                     <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//                       <h5>Period {idx + 1}</h5>
//                       <Button
//                         size="small"
//                         onClick={() => {
//                           const newEnsav = [...formData.default.ensav];
//                           newEnsav.splice(idx, 1);
//                           setFormData({
//                             ...formData,
//                             default: { ...formData.default, ensav: newEnsav }
//                           });
//                         }}
//                       >
//                         Remove
//                       </Button>
//                     </div>
//                     <TextField
//                       label="ESP Value"
//                       type="number"
//                       fullWidth
//                       value={saving.esp}
//                       onChange={(e) => {
//                         const newEnsav = [...formData.default.ensav];
//                         newEnsav[idx].esp = parseInt(e.target.value) || 0;
//                         setFormData({
//                           ...formData,
//                           default: { ...formData.default, ensav: newEnsav }
//                         });
//                       }}
//                     />
//                   </div>
//                 ))}
//                 <Button
//                   variant="outlined"
//                   onClick={() => {
//                     setFormData({
//                       ...formData,
//                       default: {
//                         ...formData.default,
//                         ensav: [
//                           ...formData.default.ensav,
//                           { esp: 0 }
//                         ]
//                       }
//                     });
//                   }}
//                 >
//                   Add Energy Saving Data
//                 </Button>
//               </div>

//             </div>
//           )}

//           {/* Filtered Data Tab */}
//           {editTab === 2 && (
//             <div style={{ marginTop: '20px' }}>
//               <Box>
//                 {/* Add New Zone-Ward Section */}
//                 <Box sx={{ mb: 3, p: 2, border: '1px solid grey', borderRadius: 1 }}>
//                   <Typography variant="subtitle1" gutterBottom>Add New Zone-Ward</Typography>
//                   <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-end' }}>
//                     <FormControl fullWidth>
//                       <InputLabel>Zone</InputLabel>
//                       <Select
//                         value={newZone}
//                         label="Zone"
//                         onChange={(e) => {
//                           setNewZone(e.target.value);
//                           setNewWard(''); // Reset ward when zone changes
//                           let wardList = DeviceAddressService.getInstance().getWards(e.target.value).filter(zone => zone.value !== 0);
//                           setWardList(wardList)
//                         }}
//                       >
//                         {zoneList.map(zone => (
//                           <MenuItem key={zone.value} value={zone.value}>{zone.label}</MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>

//                     <FormControl fullWidth>
//                       <InputLabel>Ward</InputLabel>
//                       <Select
//                         value={newWard}
//                         label="Ward"
//                         onChange={(e) => setNewWard(e.target.value)}
//                         disabled={!newZone}
//                       >
//                         {wardList.map(ward => {
//                           const combination = `${newZone}-${ward.value}`;
//                           const exists = existingCombinations.includes(combination);
//                           return (
//                             <MenuItem
//                               key={ward.value}
//                               value={ward.value}
//                               disabled={exists}
//                             >
//                               {ward.label} {exists && "(exists)"}
//                             </MenuItem>
//                           );
//                         })}
//                       </Select>
//                     </FormControl>

//                     <Button
//                       variant="contained"
//                       onClick={() => {
//                         if (newZone && newWard) {
//                           const newFilter = {
//                             zone: Number(newZone),
//                             ward: Number(newWard),
//                             data: {
//                               lmpCnt: 0,
//                               lmpOnCnt: 0,
//                               lmpNcCnt: 0,
//                               lmpOffCnt: 0,
//                               slcCnt: 0,
//                               withSlcCnt: 0,
//                               slcOnCnt: 0,
//                               slcOffCnt: 0,
//                               slcErrCnt: 0,
//                               inpFaults: { pfCnt: 0, lvCnt: 0, hvCnt: 0, isofCnt: 0 },
//                               outFaults: { hcCnt: 0, tripCnt: 0, cfCnt: 0 },
//                               othFaults: { lbCnt: 0, inaCnt: 0, doCnt: 0, emfCnt: 0 },
//                               modes: { autoCnt: 0, manCnt: 0, bypCnt: 0 }
//                             }
//                           };
//                           setFormData({
//                             ...formData,
//                             filtered: [newFilter, ...(formData.filtered || [])]
//                           });
//                           setNewZone('');
//                           setNewWard('');
//                         }
//                       }}
//                       disabled={!newZone || !newWard}
//                     >
//                       Add
//                     </Button>
//                   </Box>
//                 </Box>

//                 {/* Existing Zone-Ward List */}
//                 {formData.filtered?.map((filter, index) => (
//                   <Box key={`${filter.zone}-${filter.ward}`} sx={{
//                     mb: 3,
//                     p: 2,
//                     border: '1px solid #eee',
//                     borderRadius: 1
//                   }}>
//                     <Accordion  >
//                       <AccordionSummary

//                         expandIcon={<ExpandMoreIcon />}
//                         sx={{
//                           margin: '10px',
//                           backgroundColor: 'ButtonFace',
//                           position: 'relative', // Needed for absolute positioning of button
//                           pr: 6 // Add padding to prevent text overlap with button
//                         }}
//                       >
//                         <Typography variant="subtitle1" fontWeight="bold">
//                           Zone {filter.zone} - Ward {filter.ward}
//                         </Typography>

//                         <Button
//                           color="error"
//                           size="small"
//                           sx={{
//                             position: 'absolute',
//                             right: 100,
//                             top: '50%',
//                             transform: 'translateY(-50%)',
//                             zIndex: 1 // Ensure button stays above other elements
//                           }}
//                           onClick={(e) => {
//                             e.stopPropagation(); // Prevent accordion toggle when clicking remove
//                             const newFiltered = [...formData.filtered];
//                             newFiltered.splice(index, 1);
//                             setFormData({ ...formData, filtered: newFiltered });
//                           }}
//                         >
//                           remove
//                         </Button>
//                       </AccordionSummary>
//                       <AccordionDetails>
//                         <Box sx={{
//                           display: 'grid',
//                           gridTemplateColumns: 'repeat(2, 1fr)',
//                           gap: 2
//                         }}>
//                           {/* LMP Fields */}
//                           <TextField
//                             label="LMP Count"
//                             type="number"
//                             value={filter.data.lmpCnt || 0}
//                             onChange={(e) => {
//                               const newFiltered = [...formData.filtered];
//                               newFiltered[index].data.lmpCnt = parseInt(e.target.value) || 0;
//                               setFormData({ ...formData, filtered: newFiltered });
//                             }}
//                           />
//                           <TextField
//                             label="LMP On Count"
//                             type="number"
//                             value={filter.data.lmpOnCnt || 0}
//                             onChange={(e) => {
//                               const newFiltered = [...formData.filtered];
//                               newFiltered[index].data.lmpOnCnt = parseInt(e.target.value) || 0;
//                               setFormData({ ...formData, filtered: newFiltered });
//                             }}
//                           />
//                           <TextField
//                             label="LMP NC Count"
//                             type="number"
//                             value={filter.data.lmpNcCnt}
//                             onChange={(e) => {
//                               const newFiltered = [...formData.filtered];
//                               newFiltered[index].data.lmpNcCnt = parseInt(e.target.value) || 0;
//                               setFormData({ ...formData, filtered: newFiltered });
//                             }}
//                           />
//                           <TextField
//                             label="LMP Off Count"
//                             type="number"
//                             value={filter.data.lmpOffCnt}
//                             onChange={(e) => {
//                               const newFiltered = [...formData.filtered];
//                               newFiltered[index].data.lmpOffCnt = parseInt(e.target.value) || 0;
//                               setFormData({ ...formData, filtered: newFiltered });
//                             }}
//                           />

//                           {/* SLC Fields */}
//                           <TextField
//                             label="SLC Count"
//                             type="number"
//                             value={filter.data.slcCnt}
//                             onChange={(e) => {
//                               const newFiltered = [...formData.filtered];
//                               newFiltered[index].data.slcCnt = parseInt(e.target.value) || 0;
//                               setFormData({ ...formData, filtered: newFiltered });
//                             }}
//                           />
//                           <TextField
//                             label="SLC On Count"
//                             type="number"
//                             value={filter.data.slcOnCnt}
//                             onChange={(e) => {
//                               const newFiltered = [...formData.filtered];
//                               newFiltered[index].data.slcOnCnt = parseInt(e.target.value) || 0;
//                               setFormData({ ...formData, filtered: newFiltered });
//                             }}
//                           />
//                           <TextField
//                             label="SLC Off Count"
//                             type="number"
//                             value={filter.data.slcOffCnt}
//                             onChange={(e) => {
//                               const newFiltered = [...formData.filtered];
//                               newFiltered[index].data.slcOffCnt = parseInt(e.target.value) || 0;
//                               setFormData({ ...formData, filtered: newFiltered });
//                             }}
//                           />
//                           <TextField
//                             label="SLC Error Count"
//                             type="number"
//                             value={filter.data.slcErrCnt}
//                             onChange={(e) => {
//                               const newFiltered = [...formData.filtered];
//                               newFiltered[index].data.slcErrCnt = parseInt(e.target.value) || 0;
//                               setFormData({ ...formData, filtered: newFiltered });
//                             }}
//                           />

//                           {/* Input Faults */}
//                           <div style={{ gridColumn: 'span 2', borderBottom: '1px solid #eee', paddingBottom: '8px', marginBottom: '8px' }}>
//                             <h5>Input Faults</h5>
//                           </div>
//                           <TextField
//                             label="PF Count"
//                             type="number"
//                             value={filter.data.inpFaults.pfCnt}
//                             onChange={(e) => {
//                               const newFiltered = [...formData.filtered];
//                               newFiltered[index].data.inpFaults.pfCnt = parseInt(e.target.value) || 0;
//                               setFormData({ ...formData, filtered: newFiltered });
//                             }}
//                           />
//                           <TextField
//                             label="LV Count"
//                             type="number"
//                             value={filter.data.inpFaults.lvCnt}
//                             onChange={(e) => {
//                               const newFiltered = [...formData.filtered];
//                               newFiltered[index].data.inpFaults.lvCnt = parseInt(e.target.value) || 0;
//                               setFormData({ ...formData, filtered: newFiltered });
//                             }}
//                           />
//                           <TextField
//                             label="HV Count"
//                             type="number"
//                             value={filter.data.inpFaults.hvCnt}
//                             onChange={(e) => {
//                               const newFiltered = [...formData.filtered];
//                               newFiltered[index].data.inpFaults.hvCnt = parseInt(e.target.value) || 0;
//                               setFormData({ ...formData, filtered: newFiltered });
//                             }}
//                           />
//                           <TextField
//                             label="IsoF Count"
//                             type="number"
//                             value={filter.data.inpFaults.isofCnt}
//                             onChange={(e) => {
//                               const newFiltered = [...formData.filtered];
//                               newFiltered[index].data.inpFaults.isofCnt = parseInt(e.target.value) || 0;
//                               setFormData({ ...formData, filtered: newFiltered });
//                             }}
//                           />

//                           {/* Output Faults */}
//                           <div style={{ gridColumn: 'span 2', borderBottom: '1px solid #eee', paddingBottom: '8px', marginBottom: '8px' }}>
//                             <h5>Output Faults</h5>
//                           </div>
//                           <TextField
//                             label="HC Count"
//                             type="number"
//                             value={filter.data.outFaults.hcCnt}
//                             onChange={(e) => {
//                               const newFiltered = [...formData.filtered];
//                               newFiltered[index].data.outFaults.hcCnt = parseInt(e.target.value) || 0;
//                               setFormData({ ...formData, filtered: newFiltered });
//                             }}
//                           />
//                           <TextField
//                             label="Trip Count"
//                             type="number"
//                             value={filter.data.outFaults.tripCnt}
//                             onChange={(e) => {
//                               const newFiltered = [...formData.filtered];
//                               newFiltered[index].data.outFaults.tripCnt = parseInt(e.target.value) || 0;
//                               setFormData({ ...formData, filtered: newFiltered });
//                             }}
//                           />
//                           <TextField
//                             label="CF Count"
//                             type="number"
//                             value={filter.data.outFaults.cfCnt}
//                             onChange={(e) => {
//                               const newFiltered = [...formData.filtered];
//                               newFiltered[index].data.outFaults.cfCnt = parseInt(e.target.value) || 0;
//                               setFormData({ ...formData, filtered: newFiltered });
//                             }}
//                           />

//                           {/* Other Faults */}
//                           <div style={{ gridColumn: 'span 2', borderBottom: '1px solid #eee', paddingBottom: '8px', marginBottom: '8px' }}>
//                             <h5>Other Faults</h5>
//                           </div>
//                           <TextField
//                             label="LB Count"
//                             type="number"
//                             value={filter.data.othFaults.lbCnt}
//                             onChange={(e) => {
//                               const newFiltered = [...formData.filtered];
//                               newFiltered[index].data.othFaults.lbCnt = parseInt(e.target.value) || 0;
//                               setFormData({ ...formData, filtered: newFiltered });
//                             }}
//                           />
//                           <TextField
//                             label="INA Count"
//                             type="number"
//                             value={filter.data.othFaults.inaCnt}
//                             onChange={(e) => {
//                               const newFiltered = [...formData.filtered];
//                               newFiltered[index].data.othFaults.inaCnt = parseInt(e.target.value) || 0;
//                               setFormData({ ...formData, filtered: newFiltered });
//                             }}
//                           />
//                           <TextField
//                             label="DO Count"
//                             type="number"
//                             value={filter.data.othFaults.doCnt}
//                             onChange={(e) => {
//                               const newFiltered = [...formData.filtered];
//                               newFiltered[index].data.othFaults.doCnt = parseInt(e.target.value) || 0;
//                               setFormData({ ...formData, filtered: newFiltered });
//                             }}
//                           />
//                           <TextField
//                             label="EMF Count"
//                             type="number"
//                             value={filter.data.othFaults.emfCnt}
//                             onChange={(e) => {
//                               const newFiltered = [...formData.filtered];
//                               newFiltered[index].data.othFaults.emfCnt = parseInt(e.target.value) || 0;
//                               setFormData({ ...formData, filtered: newFiltered });
//                             }}
//                           />

//                           {/* Modes */}
//                           <div style={{ gridColumn: 'span 2', borderBottom: '1px solid #eee', paddingBottom: '8px', marginBottom: '8px' }}>
//                             <h5>Modes</h5>
//                           </div>
//                           <TextField
//                             label="Auto Count"
//                             type="number"
//                             value={filter.data.modes.autoCnt}
//                             onChange={(e) => {
//                               const newFiltered = [...formData.filtered];
//                               newFiltered[index].data.modes.autoCnt = parseInt(e.target.value) || 0;
//                               setFormData({ ...formData, filtered: newFiltered });
//                             }}
//                           />
//                           <TextField
//                             label="Man Count"
//                             type="number"
//                             value={filter.data.modes.manCnt}
//                             onChange={(e) => {
//                               const newFiltered = [...formData.filtered];
//                               newFiltered[index].data.modes.manCnt = parseInt(e.target.value) || 0;
//                               setFormData({ ...formData, filtered: newFiltered });
//                             }}
//                           />
//                           <TextField
//                             label="Byp Count"
//                             type="number"
//                             value={filter.data.modes.bypCnt}
//                             onChange={(e) => {
//                               const newFiltered = [...formData.filtered];
//                               newFiltered[index].data.modes.bypCnt = parseInt(e.target.value) || 0;
//                               setFormData({ ...formData, filtered: newFiltered });
//                             }}
//                           />
//                         </Box>
//                       </AccordionDetails>
//                     </Accordion>

//                   </Box>
//                 ))}
//               </Box>
//             </div>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenEditDialog(false)}>Cancel</Button>
//           <Button onClick={handleSave} color="primary">Save</Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// };
// export default ScheduleScreen;

import React, { useEffect, useState } from 'react';
import { Tab, Tabs, List, ListItem, Collapse, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, MenuItem, Select, FormControl, InputLabel, Typography, Box, Accordion, AccordionSummary, AccordionDetails, FormHelperText } from '@mui/material';
import { ExpandLess, ExpandMore, Edit } from '@mui/icons-material';
import LampDataService from '../../apis/lamps-data';
import DeviceDataService from '../../apis/device-data';
import { getSystemUpTimeData } from '../../query/dash-chart-query';
import { getDashboardMockData, handleSaveData } from '../../query/dash-mock-query';
import DeviceAddressService from '../../apis/device-address';
import { typeFilter } from '../../constants/constants';
import DashboardDataService from '../../apis/dashboard-data';
import MaterialTable from 'material-table';
import {
  MuiThemeProvider,
  createMuiTheme,
  makeStyles,
  createStyles,
} from "@material-ui/core/styles";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { KeyboardTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { checkUserAccess, getCheckSession } from '../../apis/auth';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const useStyles = makeStyles((theme) =>
  createStyles({
    button: {
      margin: theme.spacing(1),
    },
    table: {
      minWidth: 650,
    },
    root: {
      width: "100%",
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      marginRight: 20,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  })
);

const ScheduleScreen = () => {
  // State management
  const [activeTab, setActiveTab] = useState('out_schedule');
  const [schedules, setSchedules] = useState([]);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [currentEditData, setCurrentEditData] = useState(null);
  const [expandedDefault, setExpandedDefault] = useState(true);
  const [expandedFilter, setExpandedFilter] = useState(true);
  const classes = useStyles();
  const [newZone, setNewZone] = useState(null);
  const [zoneList, setZoneList] = useState(null);
  const [newWard, setNewWard] = useState([]);
  const [wardList, setWardList] = useState([]);
  
  // Initialize with default times (9:00 AM and 6:00 PM)
  const schStart = new Date();
  schStart.setHours(9, 0, 0, 0); // 9:00:00.000 AM
  const schEnd = new Date();
  schEnd.setHours(18, 0, 0, 0); // 6:00:00.000 PM

  // Form state for add/edit
  const [formData, setFormData] = useState({
    name: '',
    schStart: schStart,
    schEnd: schEnd,
    status: null,
    type: null,
    default: {
      lmpNcCnt: 0,
      lmpOnCnt: 0,
      slcCnt: 0,
      withSlcCnt: 0,
      lmpOffCnt: 0,
      ilmErrCnt: 0,
      outFaults: {
        hcCnt: 0,
        tripCnt: 0,
        cfCnt: 0
      },
      inpFaults: {
        isofCnt: 0,
        pfCnt: 0,
        hvCnt: 0,
        lvCnt: 0
      },
      ilmOffCnt: 0,
      slcErrCnt: 0,
      slcOffCnt: 0,
      lmpCnt: 0,
      othFaults: {
        lbCnt: 0,
        inaCnt: 0,
        doCnt: 0,
        emfCnt: 0
      },
      modes: {
        autoCnt: 0,
        manCnt: 0,
        bypCnt: 0
      },
      slcOnCnt: 0,
      ilmCnt: 0,
      ilmOnCnt: 0,
      uthrly: [],
      utdly: [],
      ensav: []
    },
    filtered: []
  });

  const [errors, setErrors] = useState({
    name: '',
    schStart: '',
    schEnd: '',
    status: ''
  });

  const validateForm = () => {
    let isValid = true;
    const newErrors = {
      name: '',
      schStart: '',
      schEnd: '',
      status: ''
    };

    // Name validation
    if (!formData.name.trim()) {
      newErrors.name = 'Schedule name is required';
      isValid = false;
    } else if (formData.name.length > 50) {
      newErrors.name = 'Name must be less than 50 characters';
      isValid = false;
    }

    // Time validation
    if (!formData.schStart) {
      newErrors.schStart = 'Start time is required';
      isValid = false;
    }

    if (!formData.schEnd) {
      newErrors.schEnd = 'End time is required';
      isValid = false;
    }
    //  else {
    //   const start = new Date(formData.schStart);
    //   const end = new Date(formData.schEnd);

    //   if (end <= start) {
    //     newErrors.schEnd = 'End time must be after Start time';
    //     isValid = false;
    //   }
    // }

    // Status validation
    if (formData.status === null || formData.status === '') {
      newErrors.status = 'Status is required';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const existingCombinations = formData.filtered?.map(f => `${f.zone}-${f.ward}`) || [];

  const history = useHistory();
  useEffect(async () => {
    var mockStatus = checkUserAccess("mock");
    var sessionStatus = await getCheckSession();
    if (sessionStatus === false || mockStatus === false) {
      history.push("/dashboard");
      return;
    }
    var data = await getDashboardMockData().catch((e) => {
      console.log("Unable to receive dashboard data");
      console.log(e)
    });
    await DeviceAddressService.getInstance().getAllAddressAPICall();
    // Get zones from service and filter out any with value 0
    const zoneList = DeviceAddressService.getInstance().getZones().filter(zone => zone.value !== 0);
    // Set the filtered list
    setZoneList(zoneList);
    if (data != null && data !== undefined) {
      const processedData = data.mockData.map(item => {
        const sdate = item.schStart?.toDate?.() || new Date(item.schStart); // handle Firestore Timestamp or raw timestamp
        const edate = item.schEnd?.toDate?.() || new Date(item.schEnd); // handle Firestore Timestamp or raw timestamp

        return {
          ...item,
          schStart: sdate,
          schEnd: edate, // e.g., 1 hour later
        };
      });

      const inSchedule = processedData.filter(item => item.type === 1);
      const outSchedule = processedData.filter(item => item.type === 2);

      const newSchedule = {
        in_schedule: inSchedule,
        out_schedule: outSchedule
      };
      console.log(JSON.stringify(newSchedule, null, 2))
      setSchedules(newSchedule);
    }
  }, [])

  // Handle tab change
  const handleTabChange = (event, newValue) => {
    // Reset form data when switching tabs
    setFormData({
      name: '',
      schStart: schStart,
      schEnd: schEnd,
      status: null,
      type: null,
      default: {
        lmpNcCnt: 0,
        lmpOnCnt: 0,
        slcCnt: 0,
        lmpOffCnt: 0,
        ilmErrCnt: 0,
        outFaults: {
          hcCnt: 0,
          tripCnt: 0,
          cfCnt: 0
        },
        inpFaults: {
          isofCnt: 0,
          pfCnt: 0,
          hvCnt: 0,
          lvCnt: 0
        },
        ilmOffCnt: 0,
        slcErrCnt: 0,
        slcOffCnt: 0,
        lmpCnt: 0,
        othFaults: {
          lbCnt: 0,
          inaCnt: 0,
          doCnt: 0,
          emfCnt: 0
        },
        modes: {
          autoCnt: 0,
          manCnt: 0,
          bypCnt: 0
        },
        slcOnCnt: 0,
        ilmCnt: 0,
        ilmOnCnt: 0,
        uthrly: [],
        utdly: [],
        ensav: []
      },
      filtered: []
    });
    // Reset errors when switching tabs
    setErrors({
      name: '',
      schStart: '',
      schEnd: '',
      status: ''
    });
    setActiveTab(newValue);
  };

  // Handle add new schedule
  const handleAddSchedule = () => {
    // Reset form data when opening add dialog
    setFormData({
      name: '',
      schStart: schStart,
      schEnd: schEnd,
      status: null,
      type: null,
      default: {
        lmpNcCnt: 0,
        lmpOnCnt: 0,
        slcCnt: 0,
        lmpOffCnt: 0,
        ilmErrCnt: 0,
        outFaults: {
          hcCnt: 0,
          tripCnt: 0,
          cfCnt: 0
        },
        inpFaults: {
          isofCnt: 0,
          pfCnt: 0,
          hvCnt: 0,
          lvCnt: 0
        },
        ilmOffCnt: 0,
        slcErrCnt: 0,
        slcOffCnt: 0,
        lmpCnt: 0,
        othFaults: {
          lbCnt: 0,
          inaCnt: 0,
          doCnt: 0,
          emfCnt: 0
        },
        modes: {
          autoCnt: 0,
          manCnt: 0,
          bypCnt: 0
        },
        slcOnCnt: 0,
        ilmCnt: 0,
        ilmOnCnt: 0,
        uthrly: [],
        utdly: [],
        ensav: []
      },
      filtered: []
    });
    // Reset errors when opening add dialog
    setErrors({
      name: '',
      schStart: '',
      schEnd: '',
      status: ''
    });
    setOpenAddDialog(true);
  };

  // Handle edit schedule
  const handleEditSchedule = (schedule) => {
    setCurrentEditData(schedule);
    setFormData(schedule);
    // Reset errors when opening edit dialog
    setErrors({
      name: '',
      schStart: '',
      schEnd: '',
      status: ''
    });
    setOpenEditDialog(true);
  };

  const handleSave = () => {
    if (!validateForm()) {
      return; // Don't proceed if validation fails
    }
    // Initialize schedules with empty arrays if undefined
    const updatedSchedules = {
      in_schedule: schedules.in_schedule || [],
      out_schedule: schedules.out_schedule || []
    };

    // Determine target schedule based on activeTab
    const targetSchedule = activeTab === 'in_schedule' ? 'in_schedule' : 'out_schedule';

    if (currentEditData) {
      // Remove from old position (in case type changed)
      ['in_schedule', 'out_schedule'].forEach(scheduleType => {
        updatedSchedules[scheduleType] = (updatedSchedules[scheduleType] || []).filter(
          s => s.name !== currentEditData.name
        );
      });

      // Add to new position
      updatedSchedules[targetSchedule] = [...(updatedSchedules[targetSchedule] || []), formData];
    } else {
      // Add new item with type
      const newItem = {
        ...formData,
        type: activeTab === 'in_schedule' ? 1 : 2
      };
      updatedSchedules[targetSchedule] = [...(updatedSchedules[targetSchedule] || []), newItem];
    }

    setSchedules(updatedSchedules);
    setCurrentEditData(null);
    setOpenAddDialog(false);
    setOpenEditDialog(false);
    setCurrentEditData(null);
    handleSaveData(updatedSchedules);
  };

  const [editTab, setEditTab] = useState(0); // For tracking which tab is active in edit dialog

  const getScheduleDataColumnList = () => {
    return [
      {
        title: 'NAME',
        field: "name",
        searchable: true,
        render: ({ name = 'N/A' }) => {
          return name;
        },
        exportTransformer: ({ name = 'N/A' }) => {
          return name;
        }
      },
      {
        title: 'STATUS',
        render: ({ status = 'N/A' }) => {
          return status.replace('_', '');
        },
        exportTransformer: ({ status = 'N/A' }) => {
          return status.replace('_', '');
        }
      },
      {
        title: 'START TIME',
        type: 'time',
        render: ({ schStart = 'N/A' }) => {
          if (schStart === 'N/A') return 'N/A';
          const date = new Date(schStart);
          return date.toLocaleTimeString('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
          });
        },
        exportTransformer: ({ schStart = 'N/A' }) => {
          if (schStart === 'N/A') return 'N/A';
          const date = new Date(schStart);
          return date.toLocaleTimeString('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
          });
        },
      },
      {
        title: 'END TIME',
        type: 'time',
        render: ({ schEnd = 'N/A' }) => {
          if (schEnd === 'N/A') return 'N/A';
          const date = new Date(schEnd);
          return date.toLocaleTimeString('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
          });
        },
        exportTransformer: ({ schEnd = 'N/A' }) => {
          if (schEnd === 'N/A') return 'N/A';
          const date = new Date(schEnd);
          return date.toLocaleTimeString('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
          });
        },
      },
      {
        title: 'TOTAL LAMPS',
        render: ({ default: defaultData = {} }) => {
          return defaultData.lmpCnt || 0;
        },
        exportTransformer: ({ default: defaultData = {} }) => {
          return defaultData.lmpCnt || 0;
        }
      },
      {
        title: 'LAMPS ON',
        render: ({ default: defaultData = {} }) => {
          return defaultData.lmpOnCnt || 0;
        },
        exportTransformer: ({ default: defaultData = {} }) => {
          return defaultData.lmpOnCnt || 0;
        }
      },
      {
        title: 'LAMPS OFF',
        render: ({ default: defaultData = {} }) => {
          return defaultData.lmpOffCnt || 0;
        },
        exportTransformer: ({ default: defaultData = {} }) => {
          return defaultData.lmpOffCnt || 0;
        }
      },
      {
        title: 'LAMPS NC',
        render: ({ default: defaultData = {} }) => {
          return defaultData.lmpNcCnt || 0;
        },
        exportTransformer: ({ default: defaultData = {} }) => {
          return defaultData.lmpNcCnt || 0;
        }
      },
      {
        title: 'SLC COUNT',
        render: ({ default: defaultData = {} }) => {
          return defaultData.withSlcCnt || 0;
        },
        exportTransformer: ({ default: defaultData = {} }) => {
          return defaultData.withSlcCnt || 0;
        }
      },
      {
        title: 'SLC COUNT',
        render: ({ default: defaultData = {} }) => {
          return defaultData.slcCnt || 0;
        },
        exportTransformer: ({ default: defaultData = {} }) => {
          return defaultData.slcCnt || 0;
        }
      },
      {
        title: 'SLC ON',
        render: ({ default: defaultData = {} }) => {
          return defaultData.slcOnCnt || 0;
        },
        exportTransformer: ({ default: defaultData = {} }) => {
          return defaultData.slcOnCnt || 0;
        }
      },
      {
        title: 'SLC OFF',
        render: ({ default: defaultData = {} }) => {
          return defaultData.slcOffCnt || 0;
        },
        exportTransformer: ({ default: defaultData = {} }) => {
          return defaultData.slcOffCnt || 0;
        }
      },
      {
        title: 'ILM COUNT',
        render: ({ default: defaultData = {} }) => {
          return defaultData.ilmCnt || 0;
        },
        exportTransformer: ({ default: defaultData = {} }) => {
          return defaultData.ilmCnt || 0;
        }
      },
      {
        title: 'ILM ON',
        render: ({ default: defaultData = {} }) => {
          return defaultData.ilmOnCnt || 0;
        },
        exportTransformer: ({ default: defaultData = {} }) => {
          return defaultData.ilmOnCnt || 0;
        }
      },
      {
        title: 'ILM OFF',
        render: ({ default: defaultData = {} }) => {
          return defaultData.ilmOffCnt || 0;
        },
        exportTransformer: ({ default: defaultData = {} }) => {
          return defaultData.ilmOffCnt || 0;
        }
      },
      {
        title: 'AUTO MODE',
        render: ({ default: defaultData = {} }) => {
          return defaultData.modes?.autoCnt || 0;
        },
        exportTransformer: ({ default: defaultData = {} }) => {
          return defaultData.modes?.autoCnt || 0;
        }
      },
      {
        title: 'MANUAL MODE',
        render: ({ default: defaultData = {} }) => {
          return defaultData.modes?.manCnt || 0;
        },
        exportTransformer: ({ default: defaultData = {} }) => {
          return defaultData.modes?.manCnt || 0;
        }
      },
      {
        title: 'BYPASS MODE',
        render: ({ default: defaultData = {} }) => {
          return defaultData.modes?.bypCnt || 0;
        },
        exportTransformer: ({ default: defaultData = {} }) => {
          return defaultData.modes?.bypCnt || 0;
        }
      },
      {
        title: 'TRIP FAULTS',
        render: ({ default: defaultData = {} }) => {
          return defaultData.outFaults?.tripCnt || 0;
        },
        exportTransformer: ({ default: defaultData = {} }) => {
          return defaultData.outFaults?.tripCnt || 0;
        }
      },
      {
        title: 'CF FAULTS',
        render: ({ default: defaultData = {} }) => {
          return defaultData.outFaults?.cfCnt || 0;
        },
        exportTransformer: ({ default: defaultData = {} }) => {
          return defaultData.outFaults?.cfCnt || 0;
        }
      },
      {
        title: 'HC FAULTS',
        render: ({ default: defaultData = {} }) => {
          return defaultData.outFaults?.hcCnt || 0;
        },
        exportTransformer: ({ default: defaultData = {} }) => {
          return defaultData.outFaults?.hcCnt || 0;
        }
      },
      {
        title: 'POWER FAULTS',
        render: ({ default: defaultData = {} }) => {
          return defaultData.inpFaults?.pfCnt || 0;
        },
        exportTransformer: ({ default: defaultData = {} }) => {
          return defaultData.inpFaults?.pfCnt || 0;
        }
      },
      {
        title: 'LOW VOLTAGE',
        render: ({ default: defaultData = {} }) => {
          return defaultData.inpFaults?.lvCnt || 0;
        },
        exportTransformer: ({ default: defaultData = {} }) => {
          return defaultData.inpFaults?.lvCnt || 0;
        }
      },
      {
        title: 'HIGH VOLTAGE',
        render: ({ default: defaultData = {} }) => {
          return defaultData.inpFaults?.hvCnt || 0;
        },
        exportTransformer: ({ default: defaultData = {} }) => {
          return defaultData.inpFaults?.hvCnt || 0;
        }
      },
      {
        title: 'ISOF FAULTS',
        render: ({ default: defaultData = {} }) => {
          return defaultData.inpFaults?.isofCnt || 0;
        },
        exportTransformer: ({ default: defaultData = {} }) => {
          return defaultData.inpFaults?.isofCnt || 0;
        }
      },
      {
        title: 'LOW BATTERY',
        render: ({ default: defaultData = {} }) => {
          return defaultData.othFaults?.lbCnt || 0;
        },
        exportTransformer: ({ default: defaultData = {} }) => {
          return defaultData.othFaults?.lbCnt || 0;
        }
      },
      {
        title: 'DOOR OPEN',
        render: ({ default: defaultData = {} }) => {
          return defaultData.othFaults?.doCnt || 0;
        },
        exportTransformer: ({ default: defaultData = {} }) => {
          return defaultData.othFaults?.doCnt || 0;
        }
      },
      {
        title: 'EMF FAULTS',
        render: ({ default: defaultData = {} }) => {
          return defaultData.othFaults?.emfCnt || 0;
        },
        exportTransformer: ({ default: defaultData = {} }) => {
          return defaultData.othFaults?.emfCnt || 0;
        }
      },
      {
        title: 'INACTIVE',
        render: ({ default: defaultData = {} }) => {
          return defaultData.othFaults?.inaCnt || 0;
        },
        exportTransformer: ({ default: defaultData = {} }) => {
          return defaultData.othFaults?.inaCnt || 0;
        }
      },
      {
        title: 'ENERGY SAVINGS',
        render: (rowData) => {
          if (rowData.default && rowData.default.ensav && rowData.default.ensav.length > 0) {
            const averageESP = rowData.default.ensav.reduce((sum, item) => sum + item.esp, 0) / rowData.default.ensav.length;
            return `${averageESP.toFixed(2)}%`;
          }
          return "0%";
        },
        exportTransformer: (rowData) => {
          if (rowData.default && rowData.default.ensav && rowData.default.ensav.length > 0) {
            const averageESP = rowData.default.ensav.reduce((sum, item) => sum + item.esp, 0) / rowData.default.ensav.length;
            return `${averageESP.toFixed(2)}%`;
          }
          return "0%";
        }
      },
      {
        title: 'ZONE COUNT',
        render: ({ filtered = [] }) => {
          return filtered.length;
        },
        exportTransformer: ({ filtered = [] }) => {
          return filtered.length;
        }
      }
    ];
  };

  const handleTimeChange = (time, timeField) => {
    // Clear any existing errors for this field
    setErrors(prev => ({
      ...prev,
      [timeField]: ''
    }));
    
    // Update the form data with the new time
    setFormData(prevState => ({
      ...prevState,
      [timeField]: time,
    }));
  };

  return (
    <div className="reports">
      <Tabs value={activeTab} onChange={handleTabChange}>
        <Tab label="OUT Schedule" value="out_schedule" />
        <Tab label="IN Schedule" value="in_schedule" />
      </Tabs>

      <div className="dashboard-table">
        <MaterialTable
          style={{
            margin: "20px 0",
            width: "100%",
          }}
          className={classes.table}
          title=""
          columns={getScheduleDataColumnList()}
          data={schedules[activeTab] || []}  // Use all items in the activeTab array
          onRowClick={(evt, rowData) => {
            handleEditSchedule(rowData);
          }}
          actions={[
            {
              icon: 'add',
              tooltip: 'Add Schedule',
              isFreeAction: true,
              onClick: (event, rowData) => {
                handleAddSchedule(rowData);
              }
            }
          ]}
          options={{
            selection: false,
            sorting: true,
            pageSize: 10,
            headerStyle: {
              backgroundColor: "#0071CE",
              color: "#FFF",
              fontSize: "0.9em",
              textAlign: "center",
            },
            actionsColumnIndex: -1,
            emptyRowsWhenPaging: false,
          }}
        />
      </div>

      {/* Add Schedule Dialog */}
      <Dialog open={openAddDialog} onClose={() => setOpenAddDialog(false)}>
        <DialogTitle>Add New {activeTab == 'in_schedule' ? 'In' : 'Out'} Schedule</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Name"
            fullWidth
            value={formData.name}
            error={!!errors.name}
            helperText={errors.name}
            onChange={(e) => {
              setFormData({ ...formData, name: e.target.value });
              // Clear error when user starts typing
              if (errors.name) {
                setErrors({ ...errors, name: '' });
              }
            }}
          />
          
          <FormControl variant="outlined" fullWidth style={{ marginTop: '10px' }}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardTimePicker
                clearable
                autoOk
                error={!!errors.schStart}
                helperText={errors.schStart}
                label="Start Time"
                value={formData.schStart}
                placeholder="HH:mm"
                InputAdornmentProps={{ position: "end" }}
                onChange={(time) => handleTimeChange(time, "schStart")}
                variant="inline"
                inputVariant="outlined"
                format="HH:mm"
              />
            </MuiPickersUtilsProvider>
          </FormControl>

          <FormControl variant="outlined" fullWidth style={{ marginTop: '10px' }}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardTimePicker
                clearable
                autoOk
                error={!!errors.schEnd}
                helperText={errors.schEnd}
                label="End Time"
                value={formData.schEnd}
                placeholder="HH:mm"
                InputAdornmentProps={{ position: "end" }}
                onChange={(time) => handleTimeChange(time, "schEnd")}
                variant="inline"
                inputVariant="outlined"
                format="HH:mm"
              />
            </MuiPickersUtilsProvider>
          </FormControl>

          <FormControl error={!!errors.status} style={{ marginTop: '10px' }}
            fullWidth margin="dense">
            <InputLabel>Status</InputLabel>
            <Select
              value={formData.status}
              onChange={(e) => {
                setFormData({ ...formData, status: e.target.value });
                // Clear error when user makes a selection
                if (errors.status) {
                  setErrors({ ...errors, status: '' });
                }
              }}
            >
              <MenuItem value="active">Active</MenuItem>
              <MenuItem value="inactive">Inactive</MenuItem>
            </Select>
            {errors.status && <FormHelperText>{errors.status}</FormHelperText>}
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenAddDialog(false)}>Cancel</Button>
          <Button onClick={handleSave} color="primary">OK</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openEditDialog} onClose={() => setOpenEditDialog(false)} fullWidth maxWidth="md">
        <DialogTitle>Edit {activeTab == 'in_schedule' ? 'In' : 'Out'} Schedule</DialogTitle>
        <DialogContent>
          <Tabs value={editTab} onChange={(e, newValue) => setEditTab(newValue)}>
            <Tab label="Basic Info" />
            <Tab label="Default Data" />
            <Tab label="Filtered Data" />
          </Tabs>

          {/* Basic Info Tab */}
          {editTab === 0 && (
            <div style={{ marginTop: '20px' }}>
              <TextField
                margin="dense"
                label="Name"
                fullWidth
                value={formData.name}
                onChange={(e) => {
                  setFormData({ ...formData, name: e.target.value });
                  // Clear error when user starts typing
                  if (errors.name) {
                    setErrors({ ...errors, name: '' });
                  }
                }}
              />
              
              <FormControl variant="outlined" fullWidth style={{ marginTop: '10px' }}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardTimePicker
                    clearable
                    autoOk
                    error={!!errors.schStart}
                    helperText={errors.schStart}
                    label="Start Time"
                    value={formData.schStart}
                    placeholder="HH:mm"
                    InputAdornmentProps={{ position: "end" }}
                    onChange={(time) => handleTimeChange(time, "schStart")}
                    variant="inline"
                    inputVariant="outlined"
                    format="HH:mm"
                  />
                </MuiPickersUtilsProvider>
              </FormControl>

              <FormControl variant="outlined" fullWidth style={{ marginTop: '10px' }}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardTimePicker
                    clearable
                    autoOk
                    error={!!errors.schEnd}
                    helperText={errors.schEnd}
                    label="End Time"
                    value={formData.schEnd}
                    placeholder="HH:mm"
                    InputAdornmentProps={{ position: "end" }}
                    onChange={(time) => handleTimeChange(time, "schEnd")}
                    variant="inline"
                    inputVariant="outlined"
                    format="HH:mm"
                  />
                </MuiPickersUtilsProvider>
              </FormControl>

              <FormControl fullWidth margin="dense">
                <InputLabel>Status</InputLabel>
                <Select
                  value={formData.status}
                  onChange={(e) => {
                    setFormData({ ...formData, status: e.target.value });
                    // Clear error when user makes a selection
                    if (errors.status) {
                      setErrors({ ...errors, status: '' });
                    }
                  }}
                >
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="inactive">Inactive</MenuItem>
                </Select>
              </FormControl>
            </div>
          )}

          {/* Default Data Tab */}
          {editTab === 1 && (
            <div style={{ marginTop: '20px', display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px' }}>
              {/* LMP Fields */}
              <TextField
                label="LMP Count"
                type="number"
                value={formData.default.lmpCnt}
                onChange={(e) => setFormData({
                  ...formData,
                  default: { ...formData.default, lmpCnt: parseInt(e.target.value) || 0 }
                })}
              />
              <TextField
                label="LMP On Count"
                type="number"
                value={formData.default.lmpOnCnt}
                onChange={(e) => setFormData({
                  ...formData,
                  default: { ...formData.default, lmpOnCnt: parseInt(e.target.value) || 0 }
                })}
              />
              <TextField
                label="LMP NC Count"
                type="number"
                value={formData.default.lmpNcCnt}
                onChange={(e) => setFormData({
                  ...formData,
                  default: { ...formData.default, lmpNcCnt: parseInt(e.target.value) || 0 }
                })}
              />
              <TextField
                label="LMP Off Count"
                type="number"
                value={formData.default.lmpOffCnt}
                onChange={(e) => setFormData({
                  ...formData,
                  default: { ...formData.default, lmpOffCnt: parseInt(e.target.value) || 0 }
                })}
              />

              {/* SLC Fields */}
              <TextField
                label="With SLC Count"
                type="number"
                value={formData.default.withSlcCnt}
                onChange={(e) => setFormData({
                  ...formData,
                  default: { ...formData.default, withSlcCnt: parseInt(e.target.value) || 0 }
                })}
              />
              <TextField
                label="SLC Count"
                type="number"
                value={formData.default.slcCnt}
                onChange={(e) => setFormData({
                  ...formData,
                  default: { ...formData.default, slcCnt: parseInt(e.target.value) || 0 }
                })}
              />
              <TextField
                label="SLC On Count"
                type="number"
                value={formData.default.slcOnCnt}
                onChange={(e) => setFormData({
                  ...formData,
                  default: { ...formData.default, slcOnCnt: parseInt(e.target.value) || 0 }
                })}
              />
              <TextField
                label="SLC Off Count"
                type="number"
                value={formData.default.slcOffCnt}
                onChange={(e) => setFormData({
                  ...formData,
                  default: { ...formData.default, slcOffCnt: parseInt(e.target.value) || 0 }
                })}
              />
              <TextField
                label="SLC Error Count"
                type="number"
                value={formData.default.slcErrCnt}
                onChange={(e) => setFormData({
                  ...formData,
                  default: { ...formData.default, slcErrCnt: parseInt(e.target.value) || 0 }
                })}
              />

              {/* ILM Fields */}
              <TextField
                label="ILM Count"
                type="number"
                value={formData.default.ilmCnt}
                onChange={(e) => setFormData({
                  ...formData,
                  default: { ...formData.default, ilmCnt: parseInt(e.target.value) || 0 }
                })}
              />
              <TextField
                label="ILM On Count"
                type="number"
                value={formData.default.ilmOnCnt}
                onChange={(e) => setFormData({
                  ...formData,
                  default: { ...formData.default, ilmOnCnt: parseInt(e.target.value) || 0 }
                })}
              />
              <TextField
                label="ILM Off Count"
                type="number"
                value={formData.default.ilmOffCnt}
                onChange={(e) => setFormData({
                  ...formData,
                  default: { ...formData.default, ilmOffCnt: parseInt(e.target.value) || 0 }
                })}
              />
              <TextField
                label="ILM Error Count"
                type="number"
                value={formData.default.ilmErrCnt}
                onChange={(e) => setFormData({
                  ...formData,
                  default: { ...formData.default, ilmErrCnt: parseInt(e.target.value) || 0 }
                })}
              />

              {/* Input Faults */}
              <div style={{ gridColumn: 'span 2', borderBottom: '1px solid #eee', paddingBottom: '8px', marginBottom: '8px' }}>
                <h4>Input Faults</h4>
              </div>
              <TextField
                label="PF Count"
                type="number"
                value={formData.default.inpFaults?.pfCnt}
                onChange={(e) => setFormData({
                  ...formData,
                  default: {
                    ...formData.default,
                    inpFaults: { ...formData.default.inpFaults, pfCnt: parseInt(e.target.value) || 0 }
                  }
                })}
              />
              <TextField
                label="LV Count"
                type="number"
                value={formData.default.inpFaults?.lvCnt}
                onChange={(e) => setFormData({
                  ...formData,
                  default: {
                    ...formData.default,
                    inpFaults: { ...formData.default.inpFaults, lvCnt: parseInt(e.target.value) || 0 }
                  }
                })}
              />
              <TextField
                label="HV Count"
                type="number"
                value={formData.default.inpFaults?.hvCnt}
                onChange={(e) => setFormData({
                  ...formData,
                  default: {
                    ...formData.default,
                    inpFaults: { ...formData.default.inpFaults, hvCnt: parseInt(e.target.value) || 0 }
                  }
                })}
              />
              <TextField
                label="IsoF Count"
                type="number"
                value={formData.default.inpFaults?.isofCnt}
                onChange={(e) => setFormData({
                  ...formData,
                  default: {
                    ...formData.default,
                    inpFaults: { ...formData.default.inpFaults, isofCnt: parseInt(e.target.value) || 0 }
                  }
                })}
              />

              {/* Output Faults */}
              <div style={{ gridColumn: 'span 2', borderBottom: '1px solid #eee', paddingBottom: '8px', marginBottom: '8px' }}>
                <h4>Output Faults</h4>
              </div>
              <TextField
                label="HC Count"
                type="number"
                value={formData.default.outFaults?.hcCnt}
                onChange={(e) => setFormData({
                  ...formData,
                  default: {
                    ...formData.default,
                    outFaults: { ...formData.default.outFaults, hcCnt: parseInt(e.target.value) || 0 }
                  }
                })}
              />
              <TextField
                label="Trip Count"
                type="number"
                value={formData.default.outFaults?.tripCnt}
                onChange={(e) => setFormData({
                  ...formData,
                  default: {
                    ...formData.default,
                    outFaults: { ...formData.default.outFaults, tripCnt: parseInt(e.target.value) || 0 }
                  }
                })}
              />
              <TextField
                label="CF Count"
                type="number"
                value={formData.default.outFaults?.cfCnt}
                onChange={(e) => setFormData({
                  ...formData,
                  default: {
                    ...formData.default,
                    outFaults: { ...formData.default.outFaults, cfCnt: parseInt(e.target.value) || 0 }
                  }
                })}
              />

              {/* Other Faults */}
              <div style={{ gridColumn: 'span 2', borderBottom: '1px solid #eee', paddingBottom: '8px', marginBottom: '8px' }}>
                <h4>Other Faults</h4>
              </div>
              <TextField
                label="LB Count"
                type="number"
                value={formData.default.othFaults?.lbCnt}
                onChange={(e) => setFormData({
                  ...formData,
                  default: {
                    ...formData.default,
                    othFaults: { ...formData.default.othFaults, lbCnt: parseInt(e.target.value) || 0 }
                  }
                })}
              />
              <TextField
                label="INA Count"
                type="number"
                value={formData.default.othFaults?.inaCnt}
                onChange={(e) => setFormData({
                  ...formData,
                  default: {
                    ...formData.default,
                    othFaults: { ...formData.default.othFaults, inaCnt: parseInt(e.target.value) || 0 }
                  }
                })}
              />
              <TextField
                label="DO Count"
                type="number"
                value={formData.default.othFaults?.doCnt}
                onChange={(e) => setFormData({
                  ...formData,
                  default: {
                    ...formData.default,
                    othFaults: { ...formData.default.othFaults, doCnt: parseInt(e.target.value) || 0 }
                  }
                })}
              />
              <TextField
                label="EMF Count"
                type="number"
                value={formData.default.othFaults?.emfCnt}
                onChange={(e) => setFormData({
                  ...formData,
                  default: {
                    ...formData.default,
                    othFaults: { ...formData.default.othFaults, emfCnt: parseInt(e.target.value) || 0 }
                  }
                })}
              />

              {/* Modes */}
              <div style={{ gridColumn: 'span 2', borderBottom: '1px solid #eee', paddingBottom: '8px', marginBottom: '8px' }}>
                <h4>Modes</h4>
              </div>
              <TextField
                label="Auto Count"
                type="number"
                value={formData.default.modes?.autoCnt}
                onChange={(e) => setFormData({
                  ...formData,
                  default: {
                    ...formData.default,
                    modes: { ...formData.default.modes, autoCnt: parseInt(e.target.value) || 0 }
                  }
                })}
              />
              <TextField
                label="Man Count"
                type="number"
                value={formData.default.modes?.manCnt}
                onChange={(e) => setFormData({
                  ...formData,
                  default: {
                    ...formData.default,
                    modes: { ...formData.default.modes, manCnt: parseInt(e.target.value) || 0 }
                  }
                })}
              />
              <TextField
                label="Byp Count"
                type="number"
                value={formData.default.modes?.bypCnt}
                onChange={(e) => setFormData({
                  ...formData,
                  default: {
                    ...formData.default,
                    modes: { ...formData.default.modes, bypCnt: parseInt(e.target.value) || 0 }
                  }
                })}
              />
              <div style={{ gridColumn: 'span 2' }}>
                <h4>Hourly Data (uthrly)</h4>
                {formData?.default?.uthrly?.map((hour, idx) => (
                  <div key={idx} style={{ border: '1px solid #ddd', padding: '10px', marginBottom: '10px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <h5>Hour {idx + 1}</h5>
                      <Button
                        size="small"
                        onClick={() => {
                          const newUthrly = [...formData.default.uthrly];
                          newUthrly.splice(idx, 1);
                          setFormData({
                            ...formData,
                            default: { ...formData.default, uthrly: newUthrly }
                          });
                        }}
                      >
                        Remove
                      </Button>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px' }}>
                      <TextField
                        label="NC Count"
                        type="number"
                        value={hour.ncCnt}
                        onChange={(e) => {
                          const newUthrly = [...formData.default.uthrly];
                          newUthrly[idx].ncCnt = parseInt(e.target.value) || 0;
                          setFormData({
                            ...formData,
                            default: { ...formData.default, uthrly: newUthrly }
                          });
                        }}
                      />
                      <TextField
                        label="ON Count"
                        type="number"
                        value={hour.onCnt}
                        onChange={(e) => {
                          const newUthrly = [...formData.default.uthrly];
                          newUthrly[idx].onCnt = parseInt(e.target.value) || 0;
                          setFormData({
                            ...formData,
                            default: { ...formData.default, uthrly: newUthrly }
                          });
                        }}
                      />
                      <TextField
                        label="OFF Count"
                        type="number"
                        value={hour.offCnt}
                        onChange={(e) => {
                          const newUthrly = [...formData.default.uthrly];
                          newUthrly[idx].offCnt = parseInt(e.target.value) || 0;
                          setFormData({
                            ...formData,
                            default: { ...formData.default, uthrly: newUthrly }
                          });
                        }}
                      />
                      <TextField
                        label="Total Count"
                        type="number"
                        value={hour.totCnt}
                        onChange={(e) => {
                          const newUthrly = [...formData.default.uthrly];
                          newUthrly[idx].totCnt = parseInt(e.target.value) || 0;
                          setFormData({
                            ...formData,
                            default: { ...formData.default, uthrly: newUthrly }
                          });
                        }}
                      />
                    </div>
                  </div>
                ))}
                <Button
                  variant="outlined"
                  onClick={() => {
                    setFormData({
                      ...formData,
                      default: {
                        ...formData.default,
                        uthrly: [
                          ...formData.default.uthrly,
                          { ncCnt: 0, onCnt: 0, offCnt: 0, totCnt: 0 }
                        ]
                      }
                    });
                  }}
                >
                  Add Hourly Data
                </Button>
              </div>

              {/* utdly Array Editor */}
              <div style={{ gridColumn: 'span 2' }}>
                <h4>Daily Data (utdly)</h4>
                {formData?.default?.utdly?.map((day, idx) => (
                  <div key={idx} style={{ border: '1px solid #ddd', padding: '10px', marginBottom: '10px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <h5>Day {idx + 1}</h5>
                      <Button
                        size="small"
                        onClick={() => {
                          const newUtdly = [...formData.default.utdly];
                          newUtdly.splice(idx, 1);
                          setFormData({
                            ...formData,
                            default: { ...formData.default, utdly: newUtdly }
                          });
                        }}
                      >
                        Remove
                      </Button>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px' }}>
                      <TextField
                        label="NC Count"
                        type="number"
                        value={day.ncCnt}
                        onChange={(e) => {
                          const newUtdly = [...formData.default.utdly];
                          newUtdly[idx].ncCnt = parseInt(e.target.value) || 0;
                          setFormData({
                            ...formData,
                            default: { ...formData.default, utdly: newUtdly }
                          });
                        }}
                      />
                      <TextField
                        label="ON Count"
                        type="number"
                        value={day.onCnt}
                        onChange={(e) => {
                          const newUtdly = [...formData.default.utdly];
                          newUtdly[idx].onCnt = parseInt(e.target.value) || 0;
                          setFormData({
                            ...formData,
                            default: { ...formData.default, utdly: newUtdly }
                          });
                        }}
                      />
                      <TextField
                        label="OFF Count"
                        type="number"
                        value={day.offCnt}
                        onChange={(e) => {
                          const newUtdly = [...formData.default.utdly];
                          newUtdly[idx].offCnt = parseInt(e.target.value) || 0;
                          setFormData({
                            ...formData,
                            default: { ...formData.default, utdly: newUtdly }
                          });
                        }}
                      />
                      <TextField
                        label="Total Count"
                        type="number"
                        value={day.totCnt}
                        onChange={(e) => {
                          const newUtdly = [...formData.default.utdly];
                          newUtdly[idx].totCnt = parseInt(e.target.value) || 0;
                          setFormData({
                            ...formData,
                            default: { ...formData.default, utdly: newUtdly }
                          });
                        }}
                      />
                    </div>
                  </div>
                ))}
                <Button
                  variant="outlined"
                  onClick={() => {
                    setFormData({
                      ...formData,
                      default: {
                        ...formData.default,
                        utdly: [
                          ...formData.default.utdly,
                          { ncCnt: 0, onCnt: 0, offCnt: 0, totCnt: 0 }
                        ]
                      }
                    });
                  }}
                >
                  Add Daily Data
                </Button>
              </div>

              {/* ensav Array Editor */}
              <div style={{ gridColumn: 'span 2' }}>
                <h4>Energy Savings (ensav)</h4>
                {formData?.default?.ensav?.map((saving, idx) => (
                  <div key={idx} style={{ border: '1px solid #ddd', padding: '10px', marginBottom: '10px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <h5>Period {idx + 1}</h5>
                      <Button
                        size="small"
                        onClick={() => {
                          const newEnsav = [...formData.default.ensav];
                          newEnsav.splice(idx, 1);
                          setFormData({
                            ...formData,
                            default: { ...formData.default, ensav: newEnsav }
                          });
                        }}
                      >
                        Remove
                      </Button>
                    </div>
                    <TextField
                      label="ESP Value"
                      type="number"
                      fullWidth
                      value={saving.esp}
                      onChange={(e) => {
                        const newEnsav = [...formData.default.ensav];
                        newEnsav[idx].esp = parseInt(e.target.value) || 0;
                        setFormData({
                          ...formData,
                          default: { ...formData.default, ensav: newEnsav }
                        });
                      }}
                    />
                  </div>
                ))}
                <Button
                  variant="outlined"
                  onClick={() => {
                    setFormData({
                      ...formData,
                      default: {
                        ...formData.default,
                        ensav: [
                          ...formData.default.ensav,
                          { esp: 0 }
                        ]
                      }
                    });
                  }}
                >
                  Add Energy Saving Data
                </Button>
              </div>
            </div>
          )}

          {/* Filtered Data Tab */}
          {editTab === 2 && (
            <div style={{ marginTop: '20px' }}>
              <Box>
                {/* Add New Zone-Ward Section */}
                <Box sx={{ mb: 3, p: 2, border: '1px solid grey', borderRadius: 1 }}>
                  <Typography variant="subtitle1" gutterBottom>Add New Zone-Ward</Typography>
                  <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-end' }}>
                    <FormControl fullWidth>
                      <InputLabel>Zone</InputLabel>
                      <Select
                        value={newZone}
                        label="Zone"
                        onChange={(e) => {
                          setNewZone(e.target.value);
                          setNewWard(''); // Reset ward when zone changes
                          let wardList = DeviceAddressService.getInstance().getWards(e.target.value).filter(zone => zone.value !== 0);
                          setWardList(wardList)
                        }}
                      >
                        {zoneList.map(zone => (
                          <MenuItem key={zone.value} value={zone.value}>{zone.label}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <FormControl fullWidth>
                      <InputLabel>Ward</InputLabel>
                      <Select
                        value={newWard}
                        label="Ward"
                        onChange={(e) => setNewWard(e.target.value)}
                        disabled={!newZone}
                      >
                        {wardList.map(ward => {
                          const combination = `${newZone}-${ward.value}`;
                          const exists = existingCombinations.includes(combination);
                          return (
                            <MenuItem
                              key={ward.value}
                              value={ward.value}
                              disabled={exists}
                            >
                              {ward.label} {exists && "(exists)"}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>

                    <Button
                      variant="contained"
                      onClick={() => {
                        if (newZone && newWard) {
                          const newFilter = {
                            zone: Number(newZone),
                            ward: Number(newWard),
                            data: {
                              lmpCnt: 0,
                              lmpOnCnt: 0,
                              lmpNcCnt: 0,
                              lmpOffCnt: 0,
                              slcCnt: 0,
                              withSlcCnt: 0,
                              slcOnCnt: 0,
                              slcOffCnt: 0,
                              slcErrCnt: 0,
                              inpFaults: { pfCnt: 0, lvCnt: 0, hvCnt: 0, isofCnt: 0 },
                              outFaults: { hcCnt: 0, tripCnt: 0, cfCnt: 0 },
                              othFaults: { lbCnt: 0, inaCnt: 0, doCnt: 0, emfCnt: 0 },
                              modes: { autoCnt: 0, manCnt: 0, bypCnt: 0 }
                            }
                          };
                          setFormData({
                            ...formData,
                            filtered: [newFilter, ...(formData.filtered || [])]
                          });
                          setNewZone('');
                          setNewWard('');
                        }
                      }}
                      disabled={!newZone || !newWard}
                    >
                      Add
                    </Button>
                  </Box>
                </Box>

                {/* Existing Zone-Ward List */}
                {formData.filtered?.map((filter, index) => (
                  <Box key={`${filter.zone}-${filter.ward}`} sx={{
                    mb: 3,
                    p: 2,
                    border: '1px solid #eee',
                    borderRadius: 1
                  }}>
                    <Accordion  >
                      <AccordionSummary

                        expandIcon={<ExpandMoreIcon />}
                        sx={{
                          margin: '10px',
                          backgroundColor: 'ButtonFace',
                          position: 'relative', // Needed for absolute positioning of button
                          pr: 6 // Add padding to prevent text overlap with button
                        }}
                      >
                        <Typography variant="subtitle1" fontWeight="bold">
                          Zone {filter.zone} - Ward {filter.ward}
                        </Typography>

                        <Button
                          color="error"
                          size="small"
                          sx={{
                            position: 'absolute',
                            right: 100,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            zIndex: 1 // Ensure button stays above other elements
                          }}
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent accordion toggle when clicking remove
                            const newFiltered = [...formData.filtered];
                            newFiltered.splice(index, 1);
                            setFormData({ ...formData, filtered: newFiltered });
                          }}
                        >
                          remove
                        </Button>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Box sx={{
                          display: 'grid',
                          gridTemplateColumns: 'repeat(2, 1fr)',
                          gap: 2
                        }}>
                          {/* LMP Fields */}
                          <TextField
                            label="LMP Count"
                            type="number"
                            value={filter.data.lmpCnt || 0}
                            onChange={(e) => {
                              const newFiltered = [...formData.filtered];
                              newFiltered[index].data.lmpCnt = parseInt(e.target.value) || 0;
                              setFormData({ ...formData, filtered: newFiltered });
                            }}
                          />
                          <TextField
                            label="LMP On Count"
                            type="number"
                            value={filter.data.lmpOnCnt || 0}
                            onChange={(e) => {
                              const newFiltered = [...formData.filtered];
                              newFiltered[index].data.lmpOnCnt = parseInt(e.target.value) || 0;
                              setFormData({ ...formData, filtered: newFiltered });
                            }}
                          />
                          <TextField
                            label="LMP NC Count"
                            type="number"
                            value={filter.data.lmpNcCnt}
                            onChange={(e) => {
                              const newFiltered = [...formData.filtered];
                              newFiltered[index].data.lmpNcCnt = parseInt(e.target.value) || 0;
                              setFormData({ ...formData, filtered: newFiltered });
                            }}
                          />
                          <TextField
                            label="LMP Off Count"
                            type="number"
                            value={filter.data.lmpOffCnt}
                            onChange={(e) => {
                              const newFiltered = [...formData.filtered];
                              newFiltered[index].data.lmpOffCnt = parseInt(e.target.value) || 0;
                              setFormData({ ...formData, filtered: newFiltered });
                            }}
                          />

                          {/* SLC Fields */}
                          <TextField
                            label="SLC Count"
                            type="number"
                            value={filter.data.slcCnt}
                            onChange={(e) => {
                              const newFiltered = [...formData.filtered];
                              newFiltered[index].data.slcCnt = parseInt(e.target.value) || 0;
                              setFormData({ ...formData, filtered: newFiltered });
                            }}
                          />
                          <TextField
                            label="SLC On Count"
                            type="number"
                            value={filter.data.slcOnCnt}
                            onChange={(e) => {
                              const newFiltered = [...formData.filtered];
                              newFiltered[index].data.slcOnCnt = parseInt(e.target.value) || 0;
                              setFormData({ ...formData, filtered: newFiltered });
                            }}
                          />
                          <TextField
                            label="SLC Off Count"
                            type="number"
                            value={filter.data.slcOffCnt}
                            onChange={(e) => {
                              const newFiltered = [...formData.filtered];
                              newFiltered[index].data.slcOffCnt = parseInt(e.target.value) || 0;
                              setFormData({ ...formData, filtered: newFiltered });
                            }}
                          />
                          <TextField
                            label="SLC Error Count"
                            type="number"
                            value={filter.data.slcErrCnt}
                            onChange={(e) => {
                              const newFiltered = [...formData.filtered];
                              newFiltered[index].data.slcErrCnt = parseInt(e.target.value) || 0;
                              setFormData({ ...formData, filtered: newFiltered });
                            }}
                          />

                          {/* Input Faults */}
                          <div style={{ gridColumn: 'span 2', borderBottom: '1px solid #eee', paddingBottom: '8px', marginBottom: '8px' }}>
                            <h5>Input Faults</h5>
                          </div>
                          <TextField
                            label="PF Count"
                            type="number"
                            value={filter.data.inpFaults.pfCnt}
                            onChange={(e) => {
                              const newFiltered = [...formData.filtered];
                              newFiltered[index].data.inpFaults.pfCnt = parseInt(e.target.value) || 0;
                              setFormData({ ...formData, filtered: newFiltered });
                            }}
                          />
                          <TextField
                            label="LV Count"
                            type="number"
                            value={filter.data.inpFaults.lvCnt}
                            onChange={(e) => {
                              const newFiltered = [...formData.filtered];
                              newFiltered[index].data.inpFaults.lvCnt = parseInt(e.target.value) || 0;
                              setFormData({ ...formData, filtered: newFiltered });
                            }}
                          />
                          <TextField
                            label="HV Count"
                            type="number"
                            value={filter.data.inpFaults.hvCnt}
                            onChange={(e) => {
                              const newFiltered = [...formData.filtered];
                              newFiltered[index].data.inpFaults.hvCnt = parseInt(e.target.value) || 0;
                              setFormData({ ...formData, filtered: newFiltered });
                            }}
                          />
                          <TextField
                            label="IsoF Count"
                            type="number"
                            value={filter.data.inpFaults.isofCnt}
                            onChange={(e) => {
                              const newFiltered = [...formData.filtered];
                              newFiltered[index].data.inpFaults.isofCnt = parseInt(e.target.value) || 0;
                              setFormData({ ...formData, filtered: newFiltered });
                            }}
                          />

                          {/* Output Faults */}
                          <div style={{ gridColumn: 'span 2', borderBottom: '1px solid #eee', paddingBottom: '8px', marginBottom: '8px' }}>
                            <h5>Output Faults</h5>
                          </div>
                          <TextField
                            label="HC Count"
                            type="number"
                            value={filter.data.outFaults.hcCnt}
                            onChange={(e) => {
                              const newFiltered = [...formData.filtered];
                              newFiltered[index].data.outFaults.hcCnt = parseInt(e.target.value) || 0;
                              setFormData({ ...formData, filtered: newFiltered });
                            }}
                          />
                          <TextField
                            label="Trip Count"
                            type="number"
                            value={filter.data.outFaults.tripCnt}
                            onChange={(e) => {
                              const newFiltered = [...formData.filtered];
                              newFiltered[index].data.outFaults.tripCnt = parseInt(e.target.value) || 0;
                              setFormData({ ...formData, filtered: newFiltered });
                            }}
                          />
                          <TextField
                            label="CF Count"
                            type="number"
                            value={filter.data.outFaults.cfCnt}
                            onChange={(e) => {
                              const newFiltered = [...formData.filtered];
                              newFiltered[index].data.outFaults.cfCnt = parseInt(e.target.value) || 0;
                              setFormData({ ...formData, filtered: newFiltered });
                            }}
                          />

                          {/* Other Faults */}
                          <div style={{ gridColumn: 'span 2', borderBottom: '1px solid #eee', paddingBottom: '8px', marginBottom: '8px' }}>
                            <h5>Other Faults</h5>
                          </div>
                          <TextField
                            label="LB Count"
                            type="number"
                            value={filter.data.othFaults.lbCnt}
                            onChange={(e) => {
                              const newFiltered = [...formData.filtered];
                              newFiltered[index].data.othFaults.lbCnt = parseInt(e.target.value) || 0;
                              setFormData({ ...formData, filtered: newFiltered });
                            }}
                          />
                          <TextField
                            label="INA Count"
                            type="number"
                            value={filter.data.othFaults.inaCnt}
                            onChange={(e) => {
                              const newFiltered = [...formData.filtered];
                              newFiltered[index].data.othFaults.inaCnt = parseInt(e.target.value) || 0;
                              setFormData({ ...formData, filtered: newFiltered });
                            }}
                          />
                          <TextField
                            label="DO Count"
                            type="number"
                            value={filter.data.othFaults.doCnt}
                            onChange={(e) => {
                              const newFiltered = [...formData.filtered];
                              newFiltered[index].data.othFaults.doCnt = parseInt(e.target.value) || 0;
                              setFormData({ ...formData, filtered: newFiltered });
                            }}
                          />
                          <TextField
                            label="EMF Count"
                            type="number"
                            value={filter.data.othFaults.emfCnt}
                            onChange={(e) => {
                              const newFiltered = [...formData.filtered];
                              newFiltered[index].data.othFaults.emfCnt = parseInt(e.target.value) || 0;
                              setFormData({ ...formData, filtered: newFiltered });
                            }}
                          />

                          {/* Modes */}
                          <div style={{ gridColumn: 'span 2', borderBottom: '1px solid #eee', paddingBottom: '8px', marginBottom: '8px' }}>
                            <h5>Modes</h5>
                          </div>
                          <TextField
                            label="Auto Count"
                            type="number"
                            value={filter.data.modes.autoCnt}
                            onChange={(e) => {
                              const newFiltered = [...formData.filtered];
                              newFiltered[index].data.modes.autoCnt = parseInt(e.target.value) || 0;
                              setFormData({ ...formData, filtered: newFiltered });
                            }}
                          />
                          <TextField
                            label="Man Count"
                            type="number"
                            value={filter.data.modes.manCnt}
                            onChange={(e) => {
                              const newFiltered = [...formData.filtered];
                              newFiltered[index].data.modes.manCnt = parseInt(e.target.value) || 0;
                              setFormData({ ...formData, filtered: newFiltered });
                            }}
                          />
                          <TextField
                            label="Byp Count"
                            type="number"
                            value={filter.data.modes.bypCnt}
                            onChange={(e) => {
                              const newFiltered = [...formData.filtered];
                              newFiltered[index].data.modes.bypCnt = parseInt(e.target.value) || 0;
                              setFormData({ ...formData, filtered: newFiltered });
                            }}
                          />
                        </Box>
                      </AccordionDetails>
                    </Accordion>
                  </Box>
                ))}
              </Box>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEditDialog(false)}>Cancel</Button>
          <Button onClick={handleSave} color="primary">Save</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ScheduleScreen;